export const TRANSLATIONS = {
	en: {
		// Header
		discover: 'Discover',
		curatedSafaris: 'Curated Safaris',
		bespokePlanner: 'Bespoke Planner',
		designBespoke: 'Design Bespoke',
		inquiries: 'Inquiries',
		savedSafaris: 'Saved Safaris',
		allTerritories: 'All Territories',
		allCollections: 'All Collections',
		selectDest: 'Select Destination',
		selectExp: 'Select Experience',
		ourStoryTab: 'Our Story',
		contactUsTab: 'Contact Us',
		savedTab: 'Saved',

		// Hero Section
		wildMeetsExquisite: 'A Wild Experience You Will Never Forget',
		discoverSouthAfrica: 'Discover South Africa',
		heroSubtitle:
			'At Elephant Expeditions, our goal is to share our passion for African animals and travel by creating a seamless, enriching experience that you will never forget. Explore South Africa’s finest luxury lodges, charming budget stays, self-drive tours, and spectacular Big 5 safaris.',
		neverForget: 'NEVER FORGET!',
		curatedTravelStyles: 'Curated Travel Styles',
		ethcialSafaris: '100% Ethical Safaris',
		conservationFocused: '100% Conservation Focused',
		authenticExperiences: 'Authentic Experiences',
		territoryPatrolStatus: 'Territory active patrol status',
		secureSabiSands: '● SECURE - SABI SANDS RESERVES',
		krugerActivityEstimate: 'Kruger wildlife activity estimate',
		highDensityHerdTracking: 'High Density Herd Tracking',
		satelliteRelayOnline: 'Satellite relay online',
		capeTownHqSync: 'Cape Town HQ Sync Link Ok',
		heroBadge: 'Biological Conservation',

		// Grid and Cards
		difficultyRelaxed: 'Relaxed',
		difficultyModerate: 'Moderate',
		difficultyActive: 'Active',
		bespokeTitle: 'Bespoke / Tailor-Made Itinerary',
		bespokeLocation: 'Custom African Destinations',
		bespokeDesc: 'Design a completely custom South African wilderness itinerary with our team.',
		days: 'days',
		fromPrice: 'From',
		perPerson: 'per person',
		reviews: 'reviews',
		featured: 'Featured',
		saveToInquiry: 'Save to Inquiry',
		saved: 'Saved',
		viewItinerary: 'View Itinerary',
		bookExpedition: 'Book Expedition',
		noResults: 'No matches found. Select broader wilderness coordinates.',

		// Our Story Section
		aboutUsHeader: 'A Heritage Written in the Dust',
		aboutUsTitlePart1: 'Our Story,',
		aboutUsTitlePart2: 'Our Passion.',
		aboutParagraph1:
			'Based in Switzerland, Elephant Expeditions was born from Kyle and Rossella Blewitt’s shared passion for Africa, its breathtaking wildlife, and its natural beauty. Together, Kyle and Rossella have built Elephant Expeditions on the pillars of wildlife conservation, ethical tourism, and genuine guest experiences. They believe that every safari should not only be unforgettable but also contribute positively to the preservation of Africa’s natural heritage. By partnering with local communities and conservation projects, Elephant Expeditions ensures that each journey supports sustainable practices and fosters a deeper understanding of the continent’s unique ecosystems.',
		aboutParagraph2:
			'At Elephant Expeditions, guests are invited to explore Africa’s breathtaking landscapes and encounter its incredible wildlife through thoughtfully designed itineraries that respect and honour the environment. Whether you’re embarking on a luxury stay, a self-drive adventure, or a photographic safari, Kyle and Rossella’s commitment to authenticity and conservation guarantees a meaningful and memorable experience that you will never forget.',
		foundingYearLabel: 'Founding Year',
		ethicalLabel: 'Ethical',
		personalLabel: 'PERSONAL',
		personalLabelDesc: 'from start to finish',
		foundersTitle: 'Meet the Founders',
		foundersTitleDesc:
			'Elephant Expeditions was built on the frontlines of the African bush and the precise standards of European luxury. Born from a shared love for wild spaces, Kyle and Rossella direct every custom safari creation directly from Switzerland.',
		founderKyleTitle: 'Co-Founder / Aviator & Photographer',
		founderKyleBio:
			'Kyle Blewitt’s journey reads like an adventure novel. A pilot since he was 15, Kyle has spent years flying over some of the world’s most breathtaking landscapes, from Africa’s vast Savannah to India’s rugged terrains and the pristine waters of the Seychelles. His work has ranged from flying for medivac operations to wildlife tracking, and his photography has captured the essence of these diverse environments.',
		founderKyleBio2:
			'Having grown up in South Africa, Kyle was immersed in the wilderness from a young age, where he developed an intense respect for Africa’s animals and ecosystems. He spent his childhood immersed in spearfishing, fishing, and discovering the rich intricacies of Africa’s fauna and flora. Over time, he cultivated a deep understanding of the delicate balance between human activity and wildlife conservation, which has become a guiding principle in his work.',
		founderKyleBio3:
			'Now living in Switzerland, Kyle felt the pull to share his love for African landscapes, its untamed beauty, and its diverse wildlife with others. Founding Elephant Expeditions was a way for him to “come home” to Africa while giving travellers the opportunity to experience the magic he’s always known.',
		founderRossellaTitle: 'Co-Founder / Educator & Conservationist',
		founderRossellaBio:
			'Rossella Blewitt’s journey is one of exploration, education, and a deep passion for animals. Born and raised in Switzerland, she is an English teacher for the Canton of Ticino. Her academic pursuits took her to the UK, Iceland, and Italy, alongside extensive travels around the world broadening her outlook.',
		founderRossellaBio2:
			'Her life took an unexpected and beautiful turn when she applied for a volunteer program with Wildlife ACT, where she helped research and track endangered species in South Africa. It was there that she met Kyle, her now-husband and cofounder of Elephant Expeditions, and fell in love not just with him, but with the continent of Africa.',
		founderRossellaBio3:
			"Since then, Rossella’s connection to Africa has only deepened. She had the unique experience of tracking pangolins through Big 5 reserves, and she continues to travel across South Africa, taking courses to expand her knowledge. Her passion for the African wildlife and its conservation drives her to continuously learn about the continent's flora and fauna.",
		founderRossellaBio4:
			"Rossella's blend of educational knowledge and hands-on bush experience enables her to connect with travelers, offering them a genuine perspective on Africa's wildlife and culture. Together with Kyle, she brings passion, knowledge, and dedication to Elephant Expeditions, creating unforgettable safari experiences.",
		coreCommitmentsTitle: 'Our Commitment to Ethical Safari',
		coreCommitmentsSubtitle:
			'At Elephant Expeditions, we believe an incredible safari should have a positive impact on the wildlife, wild spaces and communities that make it possible.',
		pillarAntiPoachingTitle: 'Supporting Conservation',
		pillarAntiPoachingDesc:
			'We carefully select lodges, reserves and experiences that actively contribute to protecting wildlife and preserving natural habitats. By travelling with us, our guests help support conservation through responsible tourism.',
		pillarCommunityTitle: 'Responsible & Ethical Travel',
		pillarCommunityDesc:
			'Animal welfare and responsible wildlife viewing are at the heart of the safaris we create. We favour ethical operators and experiences that respect wildlife and allow animals to remain truly wild.',
		pillarSovereignTrustTitle: 'Connecting Guests with Conservation',
		pillarSovereignTrustDesc:
			'We believe safari is more meaningful when you understand what you are seeing. We help our guests learn about wildlife, ecosystems and conservation, creating a deeper connection with South Africa and its natural heritage.',
		impactTitle: 'Real-Time Conservation Impact Calculator',
		impactSubtitle: 'Input your expected expedition investment to calculate your direct localized conservation action.',
		investmentLabel: 'Expected Expedition Budget (CHF)',
		calculatedImpact: 'Calculated Field Contribution',
		antiPoachingPatrols: 'Anti-Poaching Patrols',
		antiPoachingDesc: 'Fully funded field ranger hours equipped with radio & optical tracking.',
		co2Reduction: 'CO2 Habitat Preservation',
		co2Desc: 'Metric tons of biomass carbon sink protection through local savanna conservation.',
		protectedAcres: 'Protected Bio-Acreage',
		protectedDesc: 'Acres of absolute wilderness buffered with permanent boundary patrols.',
		schoolMaterialWeeks: 'School Material Weeks',
		schoolDesc: 'Weeks of primary educational support materials funded for community children.',

		// Itinerary Drawer
		overviewTab: 'Overview',
		detailedItineraryTab: 'Detailed Itinerary',
		accommodationsInclusionsTab: 'Accommodations & Inclusions',
		closeButton: 'Close',
		highlightsHeader: 'Highlights',
		accommodationsHeader: 'Accommodations',
		inclusionsHeader: 'Inclusions Included',
		dayLabel: 'Day',

		// Booking & Quote Wizard
		bespokeTripPlanner: 'Bespoke Expedition Planner',
		designBespokeTitle: 'Your Personalised Journey',
		wizardStep1Title: 'Select Your Destination',
		wizardStep1Desc: 'Choose which pristine biological sanctuaries you wish to traverse.',
		wizardStep2Title: 'Lodging Style',
		wizardStep2Desc: 'Choose your preferred camp aesthetic and comfort baseline.',
		wizardStep3Title: 'Conservation Focus',
		wizardStep3Desc: 'Direct a percentage of your booking value to direct field action.',
		wizardStep4Title: 'Expedition Details',
		wizardStep4Desc: 'Logistics, transfers, and dietary preferences in the wild.',
		wizardStep5Title: 'Contact details',
		wizardStep5Desc:
			'Our team will use your preferences to create a tailor-made South African journey, designed around you.',
		nextStep: 'Next Step',
		prevStep: 'Previous Step',
		submitting: 'Dispatching to Rangers...',
		submitInquiry: 'Submit Bespoke Inquiry',
		successTitle: 'Inquiry Safely Dispatched',
		successDesc:
			'Your request has been relayed to our wilderness hosts in Sabi Sands and Cape Town. A bespoke curator will reach out in 24 hours with your interactive itinerary.',

		// Extra UI Keys
		reservationDesk: 'Expedition Reservation desk',
		desiredDepartureDate: 'Desired Departure Date',
		travelerCount: 'Traveler Count (Guests)',
		guest: 'Guest',
		guests: 'Guests',
		aviationUpgrade: 'Aviation Charter Transfer Upgrade',
		standardBushRun: 'Standard Bush Run',
		includedInBase: 'Included in base price',
		privateCessnaCaravan: 'Private Cessna Caravan',
		cessnaCostDesc: '+CHF 1,800 group charge',
		charteredHelicopter: 'Chartered Helicopter',
		helicopterCostDesc: '+CHF 3,400 flat group rate',
		culinaryPackageLevel: 'Culinary & Dietary Package level',
		savannahClassic: 'Savannah Classic',
		gourmetDiningInc: 'Gourmet dining (Inc)',
		bushVeganOrganic: 'Bush Vegan & Organic',
		veganCostDesc: '+CHF 120 / day / person',
		gourmetCellars: 'Gourmet Cellars',
		cellarCostDesc: '+CHF 180 / day / person',
		coordinationDetailContact: 'Coordination Detail Contact',
		yourFullName: 'Your Full Name',
		yourEmail: 'Your Email',
		customNotesOrReminders: 'Custom Notes or Medication/Dietary Reminders',
		submitPrivateInquiry: 'Submit Private Inquiry',
		expeditionPendingConsultation: 'Expedition Pending Consultation',
		trackingDetailsLogged: 'Your tracking details were logged on our field radio network.',
		inquiryReferenceKey: 'Inquiry reference key',
		estTotalSum: 'Est total sum',
		preparatoryPdfRouted:
			'A comprehensive preparatory PDF detailing necessary vaccinations, flight schedule linkages, and packing requirements was routed to',
		safariPrepChecklist: 'Your Safari Preparation Checklist',
		checklistYellowFever: 'Secure an official digital Yellow Fever Certificate copy',
		checklistDuffel: 'Purchase soft-sided duffel luggage (stiff framing is forbidden in bush Cessna cabins)',
		checklistClothing: 'Order neutral khaki, green, or sand colored field trekking clothing',
		returnToExploration: 'Return to Exploration',
		daysPrivateGuided: 'Days Private Guided Experience',
		financialQuotation: 'Financial Quotation',
		baseRate: 'Base rate',
		cessnaCommuterCharter: 'Cessna Commuter Charter',
		charteredHeliTransfer: 'Chartered Heli Transfer',
		vegetarianOrganicTier: 'Vegetarian Organic Tier',
		gameCellarWinePackage: 'Game & Cellar Wine Package',
		financialQuotationNotice:
			'• Includes full Wildlife Preservation contributions, premium double occupancies canvas accommodations, and standard local private 4x4 cruiser runs.',
		estimatedPrivateTotal: 'Estimated Private Total',

		letsDesignExperience: 'Let’s Design Your Experience',
		contactIntroText:
			'Connect with us directly. Whether you have localized route questions, require private pricing, or wish to start drafting your bespoke African expedition right away, our expert team is here.',
		conciergeDesksText:
			'We operate on personal trust and deep, uncompromised regional expertise, managing custom luxury routes directly from our European planning headquarters and South African bases.',
		ourLocations: 'Our Locations',
		switzerlandAndSouthAfrica: 'Switzerland & South Africa',
		directLine: 'Direct Line',
		instantWhatsAppChat: 'Instant WhatsApp Chat',
		connectWhatsAppText: 'Connect message streams directly to Kyle and Rossella Blewitt.',
		openWhatsAppButton: 'Open WhatsApp',
		officialCorrespondence: 'Official Correspondence',
		followOurJourneys: 'Follow Our Journeys',
		guaranteedResponseText: 'Guaranteed response in 1 business day',
		inquiryForwarded: 'Inquiry Forwarded',
		inquiryForwardedText:
			'Thank you for submitting your core parameters. A copy has been drafted, and Rossella & Kyle Blewitt have been flagged. Expect custom notes inside your inbox shortly.',
		sendAnotherMessage: 'Send Another Message',
		conciergeMessageStream: 'Concierge Message Stream',
		conciergeMessageStreamText: 'Complete the fields below to transmit a direct encrypted proposal inquiry.',
		fullName: 'Full Name',
		emailAddress: 'Email Address',
		contactPhoneLine: 'Contact Phone Line',
		optionalLabel: '(Optional)',
		detailedInquiryMessage: 'Detailed Inquiry Message',
		transmittingCorrespondence: 'Transmitting Correspondence...',
		transmitMessage: 'Transmit Message',

		leadSafariPlanner: 'Lead Safari Planner',
		sovereignEncryptionSecure: 'Sovereign Encryption Secure',
		welcomeMessage:
			'Jambo! How may we craft your custom narrative into the African savannah? Tell me your preferred dates or groups.',
		typicallyReplies: 'Concierge Line • Typically replies in 5m',
		typeBespokeQuestDetail: 'Type your bespoke quest detail...',
		directWhatsAppInquire: 'Direct WhatsApp Inquire',
		safariPlannerOnline: 'Safari Planner Online',
		promptText: 'Chat live on WhatsApp with our team!',

		homeTab: 'Home',
		safarisTab: 'Safaris & Packages',
		storyTab: 'Our Story',
		contactTab: 'Contact Us',
		requestAQuote: 'Request a Quote',
		est2025Text: 'Est. 2025 • Luxury & Wilderness',
		footerAboutText:
			'We believe a great safari is about more than simply seeing wildlife. It is about understanding the places you visit, respecting the animals you encounter and recognising the importance of protecting these wild spaces for the future. We carefully choose experiences and partners that reflect our commitment to ethical tourism, conservation and meaningful connections with South Africa.',
		followOurJourneysLabel: 'Follow Our Journeys:',
		fullyCertifiedASTA: 'Fully certified by the African Sustainable Tourism Alliance.',
		termsAndConditions: 'Terms & Conditions',
		privacyPolicy: 'Privacy Policy',
		indemnity: 'Indemnity',
		wildlifeBylaws: 'Terms & Conditions',
		cessnaLuggageParameters: 'Privacy Policy',
		privacyCharter: 'Indemnity',

		filterCuratedRoutesDirectly: 'Filter Curated Routes Directly',
		customQuickSearch: 'Custom Quick Search',
		featuredPrivateExpeditions: 'Upcoming Expeditions',
		africanMasterpieces: 'African masterpieces',
		exploreCuratedCollection: 'Explore curated collection',
		craftBespokeMasterpiece: 'Cannot find your specific route? Craft a Bespoke Masterpiece.',
		tailoredWilderness: 'Tailored Wilderness',
		craftBespokeSubtitle:
			'Our interactive sketchpad lets you choose specialized territories across South Africa, adjust luxury tiers, select preferred activities , and calculate estimated costs on the fly.',
		openBespokePlanner: 'Open Bespoke Planner',
		safeguardingIvoryPathfinders: 'Safeguarding South African Wildlife',
		ourHeritage: 'Our Heritage',
		conservationPartnerships: 'Conservation Programmes',
		safarisThatProtect: 'Experiences that Protect and Conserve',
		safarisThatProtectDesc:
			'Please find out more about these associations that aim to protect and monitor endangered species.',
		over240kContributed: 'Over CHF 240k Contributed',
		empoweringCommunityRangers: 'Empowering community rangers and veterinary teams',
		lowImpactFootprints: 'Low-Impact Footprints',
		strictDoubleOccupancy: 'Strict double occupancy limits per hectare',
		curatedSafariExpeditionsTitle: 'Curated Safari Expeditions',
		curatedSafariExpeditionsDesc:
			'Private itineraries exploring highly concentrated sanctuaries with specialized aviation flights.',
		territoryLabel: 'Territory: ',
		collectionLabel: 'Collection: ',
		clearFilters: 'Clear Filters',
		noCustomMatches: 'No Custom Matches Located',
		noCustomMatchesDesc:
			'We could not locate curated safaris matching both criteria. Try modifying your filters or use our custom Bespoke Planner below.',
		seeAllSafaris: 'See All Safaris',
		dreamingAviationRouting: 'Dreaming of custom aviation routing?',
		dreamingAviationRoutingDesc:
			'Mix Serengeti parks, Rwanda gorilla tracking, and Botswana waterways together inside our custom sketchpad editor to receive rapid price quotes.',
		goToBespokePlanner: 'Go to Bespoke Planner',
		designYourWildernessJourney: 'Design Your Wilderness Journey',
		designYourWildernessJourneyDesc:
			'Draft your private safari, schedule transfers and obtain rapid estimations for your bespoke African getaway.',
		curatedCustomWishlists: 'Curated custom wishlists',
		mySavedSafaris: 'My Saved Safaris',
		mySavedSafarisDesc: 'Review your prioritized adventures or trigger booking consultations directly.',
		noSafarisCached: 'No Safaris Cached',
		noSafarisCachedDesc:
			'Click the heart icon on any curated safari card while browsing to cache your priorities here.',
		goToCuratedSafaris: 'Go to Curated Safaris',
		myActiveInquiries: 'My Active Inquiries',
		loggedLabel: 'Logged',
		bespokeDayArchitectJourney: 'Bespoke {duration}-Day Journey',
		guestsLabel: 'Guests:',
		dateLabel: 'Date:',
		commuteColon: 'Commute:',
		culinaryColon: 'Culinary:',
		destinationsColon: 'Destinations:',
		tierLevelColon: 'Tier Level:',
		reviewActiveStatus: 'Review active',
		closeInquiryPanel: 'Close Inquiry Panel',

		packageOfInterest: 'Package of Interest',
		preferredActivities: 'Preferred Activities',
		datesParameters: 'Dates & Parameters',
		personalCredentials: 'Personal Credentials',
		stageLabel: 'Stage',
		ofLabel: 'of',
		selectCoreExperienceStyle: 'Select Core Experience Style',
		howWishToSleepCommute: 'How Do You Wish to Sleep & Commute?',
		howWishToSleepCommuteDesc:
			'Identify the aesthetic rhythm of shelter and transport that best mirrors your travel standard.',
		exploreSpecializedActivities: 'Explore Specialized Concession Activities',
		whatCapturesImagination: 'What Captures Your Imagination?',
		whatCapturesImaginationDesc:
			'Select the experiences that interest you most. Our team will use your choices to help create a journey tailored around you.',
		timelineBudgetGroupParams: 'Timeline, Budget & Group Parameters',
		expeditionDynamics: 'Expedition Dynamics',
		expeditionDynamicsDesc:
			'Specify details about your party size, preferred transportation style, and targeted travel calendar.',
		dateFromWithAsterisk: 'Date From *',
		dateToWithAsterisk: 'Date To *',
		howMuchToSpendWithAsterisk: 'What budget would you like us to work with? *',
		typeOfGroup: 'Type of Group',
		transportationChoice: 'Transportation Choice',
		numberOfGuests: 'Number of Guests',
		childrenAgesLabel: "Children's Ages (Optional)",
		childrenAgesPlaceholder: 'e.g. 6, 11 (leave blank if adults only)',
		childrenAgesHelp:
			'Certain lodges, game drives, and safari activities have minimum age guidelines. Sharing children’s ages ensures we select the most suitable accommodations and family-friendly experiences.',
		estimatedBlueprintBase: 'Estimated Blueprint Base',
		computedDuration: 'Computed Duration:',
		nightsFor: 'nights for',
		paxLabel: 'PAX',
		includesLeviesNotice: '*Includes reserve levies, excluding flights',
		fullNameWithAsterisk: 'Full Name *',
		emailAddressWithAsterisk: 'Email Address *',
		phoneNumberWithAsterisk: 'Phone Number *',
		whereDoYouLive: 'Where Do You Live? (City & Country)',
		preferredDepartureAirport: 'Preferred Departure Airport (City)',
		wouldYouLikeFlightSuggestions: 'Would You Like Flight Suggestions?',
		yesSendFlightIdeas: 'Yes, send flight ideas',
		noAlreadySorted: 'No, already sorted',
		anySpecialRequestsOrPreferences: 'Any Special Requests or Preferences?',
		textareaSpecialRequestsPlaceholder:
			'Describe specialized dietaries, tracking limits, custom transfers, photography loads, or accessibility specifications...',
		mandatoryCredentialsAlert:
			'Kindly supply all mandatory credentials (Name, Email, and Phone Number) so that we may assign a private planner.',
		telemetrySecure: 'Telemetry Secure',
		transmissionAlert: 'Transmission Alert',

		curatedMasterpieceTour: 'Curated Masterpiece Tour /',
		durationLabel: 'Duration',
		paceCategoryLabel: 'Pace Category',
		rateStartLabel: 'Rate Start',
		journeyOverview: 'Journey Overview',
		wildLuxuryAccommodations: 'Wild Luxury Accommodations',
		dayByDayExperience: 'Day-by-Day Experience',
		selectDayBelow: 'The below itinerary is an example of what to expect…',
		dayItinerary: 'Day {day} Itinerary',
		dailyHighlightsEvents: 'Daily Highlights & Events',
		premiumInclusions: 'Premium Inclusions',
		requiredPreparations: 'Required Preparations',
		checklistYellowFeverPrep: 'Valid yellow fever proof & anti-malaria prophylaxis',
		checklistLuggageLimit: 'Flexible duffle bag soft canvas luggage limit: 15kg',
		checklistVisaPrep: 'Entry Visas compiled 30 days prior to departure',
		totalPrivateRate: 'Total Private Rate',
		inquireBookNow: 'Inquire & Book Now',
		daysLabel: 'Days',

		// Wizard Options
		styleLuxuryTitle: 'Luxury Stay',
		styleLuxuryDesc:
			'Stay in carefully selected luxury lodges and private reserves, combining exceptional comfort, beautiful locations and unforgettable safari experiences.',
		styleLuxuryPrice: 'Starts around CHF 1,200/night',
		styleBudgetTitle: 'Budget Stay',
		styleBudgetDesc:
			'Enjoy authentic, comfortable accommodation that offers excellent value while keeping you close to South Africa’s wildlife and natural beauty.',
		styleBudgetPrice: 'Starts around CHF 350/night',
		styleSelfDriveTitle: 'Self-Drive Tour',
		styleSelfDriveDesc:
			'Explore South Africa at your own pace with a personalised route, hand-picked accommodation and our support throughout your journey.',
		styleSelfDrivePrice: 'Starts around CHF 480/night',
		styleBig5Title: 'Big 5 Safari Tour',
		styleBig5Desc:
			'Experience expertly guided game drives in some of South Africa’s best wildlife reserves, with opportunities to encounter the iconic Big Five and much more.',
		styleBig5Price: 'Starts around CHF 850/night',
		stylePersonalisedTitle: 'Personalised Package',
		stylePersonalisedDesc:
			'A completely tailor-made journey built around you — combining your preferred destinations, accommodation, activities and travel style into one seamless itinerary.',
		stylePersonalisedPrice: 'Tailored pricing setup',
		styleSustainableTitle: 'Sustainable Interactions and Conservation',
		styleSustainableDesc:
			'Discover the conservation work behind your safari through ethical wildlife experiences, conservation initiatives and opportunities to learn from the people protecting South Africa’s wildlife.',
		styleSustainablePrice: 'Starts around CHF 650/night',

		interestBig5Title: 'Big 5 Spotting',
		interestBig5Label: 'Classic Game Drives',
		interestBig5Desc:
			'Experience unforgettable wildlife encounters on guided game drives, with opportunities to see the Big Five and the incredible variety of wildlife South Africa has to offer.',
		interestSportsTitle: 'Sports & Active Experiences',
		interestSportsLabel: 'Outdoor Adventure',
		interestSportsDesc:
			'Add adventure to your journey with activities such as hiking, cycling, golf, horse riding and other outdoor experiences selected around your interests.',
		interestOceanTitle: 'Ocean Experiences',
		interestOceanLabel: 'Coastal & Marine',
		interestOceanDesc:
			'Explore South Africa’s coastline with experiences including diving, whale watching, turtle encounters, surfing, fishing and other marine activities.',
		interestScenicTitle: 'Scenic Flights',
		interestScenicLabel: 'Low-Altitude Flight',
		interestScenicDesc:
			'See South Africa from a different perspective with scenic flights over spectacular coastlines, mountains, wildlife reserves and breathtaking landscapes.',
		interestConservationTitle: 'Sustainable Conservation',
		interestConservationLabel: 'Ecosystem Sustainability',
		interestConservationDesc:
			'Gain a deeper understanding of wildlife protection through ethical conservation experiences, educational activities and opportunities to learn about the work being done on the ground.',
		interestCulinaryTitle: 'Culinary Experience',
		interestCulinaryLabel: 'Fine Food & Wine',
		interestCulinaryDesc:
			'Discover South Africa through its food and wine, from traditional local flavours and vineyard experiences to exceptional restaurants and memorable bush dining.',
		interestPhotographyTitle: 'Wildlife Photography',
		interestPhotographyLabel: 'Photographic Masterclass',
		interestPhotographyDesc:
			'Doors-off photo flight slots, dual-mount lens shock absorbers, and animal alignment specialists.',

		groupCouple: 'Couple',
		groupFamily: 'Family',
		groupSolo: 'Solo Traveler',
		groupFriends: 'Group of friends',
		groupOther: 'Other',

		transportOrganised: 'Organised Transport',
		transportSelfDrive: 'Self-driving',
		transSelfDriving: 'Self-driving',
		transOrganised: 'Organised Transport',

		wizardSuccessSecure: 'Proposal Lodged Securely',
		wizardSuccessDesc:
			'Sovereign concession tracking codes and flight permits are currently being pre-reserved against local registries.',
		wizardSuccessPlanner: 'Travel Planner:',
		wizardSuccessCredentials: 'Credentials Sent:',
		wizardSuccessDuration: 'Duration Planned:',
		wizardSuccessNights: 'Nights (Guaranteed private escort)',
		wizardSuccessGroup: 'Group Seating:',
		wizardSuccessSecondary: 'Design Secondary Route',
		wizardSuccessUnlock: 'By submitting, you connect directly with our safari team who will prepare your proposal.',
		wizardPrev: 'Previous',
		wizardNext: 'Next Step',
		wizardSubmit: 'Submit Proposal Request',
		wizardSubmitting: 'Transmitting Proposal...',
		wizardAssignedId: 'Assigned Concession ID',
		recommendedLevel: 'Recommended Level',

		// Testimonials / Guest Reviews / Guarantees
		simplifyingJourneyTitle: 'Simplifying Your Perfect Journey',
		simplifyingJourneyDesc1:
			'Our travel packages simplify the booking process by catering to all types of interests and budgets. We cover every aspect of your trip, such as accommodation, activities and transfers.',
		simplifyingJourneyDesc2:
			'We want you to make the most of your journey, ensuring it is a wonderful experience you’ll',
		guestChronicles: 'Guest Reviews',
		guestChroniclesDesc: 'Real experiences: our guests say it best.',
		selectSafariStory: 'Select Safari Story',
		verifiedAdventurer: 'Verified Adventurer • {location}',
		prevReview: 'Previous Review',
		nextReview: 'Next Review',

		// Testimonial Specific Metadata (leaving quotes in english)
		tripBespokeSelfDrive: 'Bespoke Self-Drive Expedition',
		tripCuratedWilderness: 'Curated Wilderness Safari',
		tripUltraLuxuryAir: 'Ultra-Luxury Private Air Transfer Charter',
		highlightFlexibility: 'Flexibility, Remote Serenity, & Waterhole Encounters',
		highlightMagical: 'Magical Animal Encounters & Spectacular Night Safaris',
		highlightIncomparable: 'Incomparable Luxury & Wilderness Alignment',
		destTalamati: 'Kruger National Park (Talamati Bushveld Camp)',
		destLionReserves: 'Kruger National Park & Lion Reserves',
		destSandibe: 'Okavango Delta (Sandibe Private Reserve)',

		// Travel Styles UI
		readNarrative: 'Read Narrative',
		hideNarrative: 'Hide Narrative',
		discoverOurPackages: 'Discover our Packages',
		pristineHighlights: 'Pristine Highlights Included',
		startFrom: 'Start from',
		ourServicesTab: 'Our Services & Travel Styles',
		seamlessEnrichingTitle: 'Seamless, Enriching Safaris',
		seamlessEnrichingSubtitle1:
			'Our goal at Elephant Expeditions is to share our passion for African animals and travel by creating a seamless, enriching experience that you will never forget.',
		seamlessEnrichingSubtitle2:
			'Tailored for individuals, families, and groups from Europe and around the world, our target audience is those interested in exploring South Africa’s rich wildlife and natural beauty.',

		// Travel Styles Content English
		style_luxury_title: 'Luxury Stays',
		style_luxury_subtitle: 'Upscale accommodation in exclusive lodges and private reserves.',
		style_luxury_desc:
			'Immerse yourself in complete sanctuary. Settle into upscale accommodation in exclusive lodges and private reserves designed with precision detail to combine high-end European standard comforts with direct, uninterrupted nature access.',
		style_luxury_h1: 'Upscale accommodation in exclusive lodges and private reserves.',
		style_luxury_h2: 'Guided tours to observe animals in exclusive reserves.',
		style_luxury_h3: 'Premium services like spa treatments and customised itineraries.',
		style_luxury_eco: 'Eco-Luxe Gold Alliance',

		style_budget_title: 'Budget Stays',
		style_budget_subtitle: 'More affordable options without compromising on experience.',
		style_budget_desc:
			'Experience the magic of the African bush closely on a more affordable tier. Settle into exceptional, charming lodges and guesthouses that prioritize high comfort, warmth, and raw authenticity.',
		style_budget_h1: 'More affordable options without compromising on experience.',
		style_budget_h2:
			'Exceptional accommodation, including charming lodges and guesthouses that offer comfort and quality.',
		style_budget_h3: 'Guided safari tours, affordable options with all-inclusive or self-catering plans.',
		style_budget_eco: 'Low-Footprint Green Standard',

		style_selfdrive_title: 'Self-drive Tours',
		style_selfdrive_subtitle: 'For adventurous travelers who prefer to drive themselves.',
		style_selfdrive_desc:
			'The ultimate path of unscripted personal discovery. We provide completely well-planned itineraries, recommended routes, and pre-booked premium accommodation and activities to ensure you enjoy a completely hassle-free self-drive safari.',
		style_selfdrive_h1: 'Well-planned itineraries, recommended routes, and pre-booked accommodation.',
		style_selfdrive_h2: 'Car rentals suggestions.',
		style_selfdrive_h3: 'Tips for navigating the terrain and exploring regions at your own perfect pace.',
		style_selfdrive_eco: 'Route Carbon-Compensation Offsets',

		style_big5_title: 'Big 5 Safari Tours',
		style_big5_subtitle: 'Tailored safaris focused on spotting the legendary Big 5.',
		style_big5_desc:
			'Dedicated safaris curated to help you spot the legendary Big 5: Lion, Leopard, Elephant, Rhino, and Buffalo. Enjoy guided excursions led by top tracking specialists across South Africa’s most spectacular national parks.',
		style_big5_h1: 'Tailored safaris focusing on spotting the Big 5 (Lion, Leopard, Elephant, Rhino, and Buffalo).',
		style_big5_h2: 'Focus on the "Big 5" animals with guided tours in stunning reserves and national parks.',
		style_big5_h3: 'Phenomenal opportunities for tracking, photography, and educational bush experiences.',
		style_big5_eco: 'Ranger Support Trust Subsidies',

		style_personalized_title: 'Personalised Packages',
		style_personalized_subtitle: 'More Than Just a Safari Experience. Tailored to you.',
		style_personalized_desc:
			'Bespoke designs built to capture your personal definition of absolute wilderness adventure. Experience a real taste of Africa, whether you seek raw wildlife, scenic panoramas, rich culinary options, or deep cultural connections.',
		style_personalized_h1:
			'Tailored to your preferences: wildlife, scenic landscapes, beach life, culinary or cultural steps.',
		style_personalized_h2: 'Activities like scenic flights, hippo cruises, whale watching, and deep fishing guides.',
		style_personalized_h3: 'Possibility of professional photographic guide accompaniment to capture your journey.',
		style_personalized_eco: 'Direct Local Community Wages',
		style_sustainable_title: 'Sustainable Interactions',
		style_sustainable_subtitle: 'Conservation experiences. Immerse in efforts to preserve wildlife.',
		style_sustainable_tag: 'Active Custodianship',
		style_sustainable_desc:
			'Immerse yourself deeply in active conservation effort. Engage with hands-on, high-integrity wildlife frameworks that yield an intimate, profound understanding of South Africa’s preservation pledges.',
		style_sustainable_h1: 'Hands-on experiences for a deep understanding of preserving African fauna.',
		style_sustainable_h2:
			'May include participating in rhino dehorning efforts, pangolin walks, or monitoring sessions.',
		style_sustainable_h3: 'Sustainable interactions like elephant encounters protecting creature well-being.',
		style_sustainable_eco: '100% Ethical Certification Approved',
	},
	it: {
		// Header
		discover: 'Scopri',
		curatedSafaris: 'Safari Curati',
		bespokePlanner: 'Bespoke Planner',
		designBespoke: 'Disegna su Misura',
		inquiries: 'Richieste',
		savedSafaris: 'Safari Salvati',
		allTerritories: 'Tutti i Territori',
		allCollections: 'Tutte le Collezioni',
		selectDest: 'Seleziona Destinazione',
		selectExp: 'Seleziona Esperienza',
		ourStoryTab: 'La Nostra Storia',
		contactUsTab: 'Contattaci',
		savedTab: 'Salvati',

		// Hero Section
		wildMeetsExquisite: "Un'Esperienza Selvaggia che Non Dimenticherete Mai",
		discoverSouthAfrica: 'Scopri il Sudafrica',
		heroSubtitle:
			"Presso Elephant Expeditions, il nostro obiettivo è condividere con voi la nostra passione per gli animali africani e per i viaggi, creando un'esperienza di viaggio fluida e arricchente che NON DIMENTICHERETE MAI! Esplorate i migliori lodge di lusso del Sud Africa, i suggestivi soggiorni economici, i tour self-drive e gli spettacolari safari alla ricerca dei Big 5.",
		neverForget: 'NON DIMENTICHERETE MAI!',
		curatedTravelStyles: 'Stili di Viaggio Curati',
		ethcialSafaris: 'Safari etici al 100%',
		conservationFocused: 'Interamente incentrato sulla conservazione',
		authenticExperiences: 'Esperienze autentiche',
		territoryPatrolStatus: 'Stato pattuglia attiva del territorio',
		secureSabiSands: '● SICURO - RISERVE SABI SANDS',
		krugerActivityEstimate: 'Attività stimata fauna selvaggia Kruger',
		highDensityHerdTracking: 'Tracciamento Mandria ad Alta Densità',
		satelliteRelayOnline: 'Relè satellitare online',
		capeTownHqSync: 'Connessione Kapstadt HQ OK',
		heroBadge: 'Conservazione Biologica',

		// Grid and Cards
		difficultyRelaxed: 'Rilassato',
		difficultyModerate: 'Moderato',
		difficultyActive: 'Attivo',
		bespokeTitle: 'Itinerario Su Misura / Personalizzato',
		bespokeLocation: 'Destinazioni Africane Personalizzate',
		bespokeDesc: 'Progetta un itinerario completamente personalizzato in Sudafrica insieme al nostro team.',
		days: 'giorni',
		fromPrice: 'Da',
		perPerson: 'a persona',
		reviews: 'recensioni',
		featured: 'In Evidenza',
		saveToInquiry: 'Salva nella Richiesta',
		saved: 'Salvato',
		viewItinerary: 'Vedi Itinerario',
		bookExpedition: 'Prenota Spedizione',
		noResults: 'Nessun risultato trovato. Seleziona coordinate più ampie.',

		// Our Story Section
		aboutUsTitlePart1: 'La nostra storia, ',
		aboutUsTitlePart2: 'La nostra passione.',
		aboutUsTitle: 'Dove il lusso serve come scudo per la natura selvaggia.',
		aboutParagraph1:
			"Con sede in Svizzera, Elephant Expeditions è nata dalla passione condivisa di Kyle e Rossella Blewitt per l'Africa, la sua fauna mozzafiato e la sua bellezza naturale. Insieme, Kyle e Rossella hanno costruito Elephant Expeditions sui pilastri della conservazione della fauna selvatica, del turismo etico e di esperienze autentiche per gli ospiti. Credono che ogni safari non debba solo essere indimenticabile, ma debba anche contribuire positivamente alla conservazione del patrimonio naturale dell'Africa. Collaborando con le comunità locali e con i progetti di conservazione, Elephant Expeditions garantisce che ogni viaggio supporti pratiche sostenibili e favorisca una comprensione più profonda dei fragili ecosistemi del continente.",
		aboutParagraph2:
			"Presso Elephant Expeditions, gli ospiti sono invitati a esplorare i paesaggi mozzafiato dell'Africa e a incontrare la sua incredibile fauna selvatica attraverso itinerari attentamente progettati che rispettano e onorano l'ambiente. Sia che stiate intraprendendo un soggiorno di lusso, un'avventura in self-drive o un safari fotografico, l'impegno di Kyle e Rossella per l'autenticità e la conservazione garantisce un'esperienza significativa e memorabile che porterete per sempre nel cuore.",
		foundingYearLabel: 'Anno di Fondazione',
		ethicalLabel: 'Etica',
		personalLabel: 'PERSONALE',
		personalLabelDesc: "dall'inizio alla fine",
		foundersTitle: 'Incontra i Fondatori',
		foundersTitleDesc:
			"Elephant Expeditions è nata dall'incontro tra la natura incontaminata della savana africana e i rigorosi standard del lusso europeo. Frutto di una passione condivisa per gli spazi selvaggi, l'azienda vede Kyle e Rossella curare personalmente la creazione di ogni safari su misura direttamente dalla Svizzera.",
		founderKyleTitle: 'Cofondatore / Aviatore e fotografo',
		founderKyleBio:
			"Il percorso di Kyle Blewitt sembra uscito da un romanzo d'avventura. Pilota dall'età di 15 anni, Kyle ha trascorso anni sorvolando alcuni dei paesaggi più spettacolari del mondo: dalle vaste savane africane ai terreni impervi dell'India, fino alle acque incontaminate delle Seychelles. La sua carriera ha spaziato dalle missioni di evacuazione medica e dal trasporto merci in aree remote al pilotaggio di jet privati ​​tra Europa, Nord Africa e Asia. Eppure, ovunque lo portino i suoi viaggi, il suo cuore torna sempre a richiamarlo verso la savana africana.",
		founderKyleBio2:
			"Dopo essere cresciuto in Sudafrica, Kyle è stato immerso nella natura selvaggia fin dalla giovane età, dove ha sviluppato un intenso rispetto per gli animali e gli ecosistemi africani. Ha trascorso la sua infanzia immerso nella pesca subacquea, nella pesca e nella scoperta delle ricche complessità della fauna e della flora africane. Col tempo, ha coltivato una profonda comprensione del delicato equilibrio tra l'attività umana e la conservazione della fauna selvatica, che è diventato un principio guida nel suo lavoro.",
		founderKyleBio3:
			"Ora residente in Svizzera, Kyle ha sentito il richiamo di condividere il suo amore per i paesaggi africani, la loro bellezza selvaggia e la loro fauna diversificata con gli altri. Fondare Elephant Expeditions è stato per lui un modo per “tornare a casa” in Africa, offrendo ai viaggiatori l'opportunità di vivere la magia che ha sempre conosciuto.",
		founderRossellaTitle: 'Cofondatrice / Educatrice e conservazionista',
		founderRossellaBio:
			"Il percorso di Rossella Blewitt è all'insegna dell'esplorazione, della formazione e di una profonda passione per gli animali. Nata e cresciuta in Svizzera, è insegnante di inglese nel Canton Ticino. Il suo iter formativo l'ha portata nel Regno Unito, in Islanda e in Italia, affiancato da numerosi viaggi in tutto il mondo che hanno ampliato i suoi orizzonti.",
		founderRossellaBio2:
			'La sua vita ha preso una piega inaspettata e meravigliosa quando ha aderito a un programma di volontariato con Wildlife ACT, occupandosi di ricerca e monitoraggio di specie a rischio di estinzione in Sudafrica. È stato lì che ha conosciuto Kyle – suo attuale marito e co-fondatore di Elephant Expeditions – e si è innamorata non solo di lui, ma anche del continente africano.',
		founderRossellaBio3:
			'Da allora, il legame di Rossella con l\'Africa si è fatto sempre più profondo. Ha vissuto l\'esperienza unica di seguire le tracce dei pangolini nelle riserve che ospitano i "Big Five" e continua a viaggiare in tutto il Sudafrica, frequentando corsi per approfondire le proprie conoscenze. La sua passione per la fauna selvatica africana e per la sua conservazione la spinge ad apprendere continuamente tutto ciò che riguarda la flora e la fauna del continente.',
		founderRossellaBio4:
			'La combinazione di conoscenze accademiche ed esperienza pratica nella natura selvaggia permette a Rossella di connettersi con i viaggiatori, offrendo loro una prospettiva autentica sulla fauna e la cultura africana. Insieme a Kyle, porta passione, conoscenza e dedizione in Elephant Expeditions, creando esperienze safari indimenticabili.',
		coreCommitmentsTitle: 'Il Nostro Impegno per un Safari Etico',
		coreCommitmentsSubtitle:
			'In Elephant Expeditions, crediamo che un safari straordinario debba avere un impatto positivo sulla fauna selvatica, sugli spazi incontaminati e sulle comunità che lo rendono possibile.',
		pillarAntiPoachingTitle: 'Sostegno alla Conservazione',
		pillarAntiPoachingDesc:
			'Selezioniamo attentamente lodge, riserve ed esperienze che contribuiscono attivamente alla protezione della fauna e alla conservazione degli habitat naturali. Viaggiando con noi, i nostri ospiti supportano la conservazione attraverso un turismo responsabile.',
		pillarCommunityTitle: 'Viaggi Responsabili ed Etici',
		pillarCommunityDesc:
			'Il benessere degli animali e l’osservazione rispettosa della fauna selvatica sono al centro dei safari che creiamo. Privilegiamo operatori ed esperienze etiche che rispettano gli animali e permettono loro di rimanere autenticamente liberi e selvaggi.',
		pillarSovereignTrustTitle: 'Connettere gli Ospiti con la Conservazione',
		pillarSovereignTrustDesc:
			'Crediamo che un safari sia più significativo quando si comprende ciò che si osserva. Aiutiamo i nostri ospiti a conoscere la fauna selvatica, gli ecosistemi e la conservazione, creando un legame più profondo con il Sudafrica e il suo patrimonio naturale.',
		impactTitle: 'Calcolatore di Impatto della Conservazione in Tempo Reale',
		impactSubtitle:
			"Inserisci il tuo budget stimato per calcolare l'azione di conservazione locale finanziata direttamente.",
		investmentLabel: 'Budget di Spedizione Previsto (CHF)',
		calculatedImpact: 'Contributo Calcolato sul Campo',
		antiPoachingPatrols: 'Pattuglie Antibracconaggio',
		antiPoachingDesc: 'Ore di pattugliamento dei ranger completamente finanziate con tracciamento radio.',
		co2Reduction: 'Preservazione Habitat CO2',
		co2Desc: 'Tonnellate di carbonio protette grazie alla salvaguardia attiva della savana locale.',
		protectedAcres: 'Superficie Protetta',
		protectedDesc: 'Acri di natura incontaminata protetti con pattugliamenti continui.',
		schoolMaterialWeeks: 'Materiale Scolastico (Settimane)',
		schoolDesc: 'Settimane di materiale scolastico primario finanziate per i bambini delle comunità locali.',

		// Itinerary Drawer
		overviewTab: 'Panoramica',
		detailedItineraryTab: 'Itinerario Dettagliato',
		accommodationsInclusionsTab: 'Alloggi e Servizi Inclusi',
		closeButton: 'Chiudi',
		highlightsHeader: 'In Evidenza',
		accommodationsHeader: 'Alloggi',
		inclusionsHeader: 'Cosa è Incluso',
		dayLabel: 'Giorno',

		// Booking & Quote Wizard
		bespokeTripPlanner: 'Pianificatore Safari Personalizzato',
		designBespokeTitle: 'Il Tuo Viaggio Personalizzato',
		wizardStep1Title: 'Seleziona la tua Destinazione',
		wizardStep1Desc: 'Scegli quali santuari naturali incontaminati desideri attraversare.',
		wizardStep2Title: 'Stile di Alloggio',
		wizardStep2Desc: 'Scegli lo stile di campo e il livello di comfort che preferisci.',
		wizardStep3Title: 'Focus sulla Conservazione',
		wizardStep3Desc: "Destina una percentuale del tuo viaggio a un'azione sul campo.",
		wizardStep4Title: 'Dettagli della Spedizione',
		wizardStep4Desc: 'Logistica, trasporti e preferenze alimentari nella savana.',
		wizardStep5Title: 'Dettagli di Contatto',
		wizardStep5Desc:
			'Il nostro team utilizzerà le tue preferenze per creare un viaggio su misura in Sudafrica, pensato intorno a te.',
		nextStep: 'Avanti',
		prevStep: 'Indietro',
		submitting: 'Inoltro ai Guardaparco...',
		submitInquiry: 'Invia Richiesta su Misura',
		successTitle: 'Richiesta Inviata con Successo',
		successDesc:
			'La tua richiesta è stata trasmessa ai nostri referenti a Sabi Sands e Kapstadt. Un curatore esperto ti contatterà entro 24 ore con una proposta di itinerario interattivo.',

		// Extra UI Keys
		reservationDesk: 'Ufficio Prenotazioni Spedizioni',
		desiredDepartureDate: 'Data di Partenza Desiderata',
		travelerCount: 'Numero di Viaggiatori (Ospiti)',
		guest: 'Ospite',
		guests: 'Ospiti',
		aviationUpgrade: 'Upgrade Trasferimento Charter Aereo',
		standardBushRun: 'Corsa Standard nella Savana',
		includedInBase: 'Incluso nel prezzo base',
		privateCessnaCaravan: 'Cessna Caravan Privato',
		cessnaCostDesc: '+CHF 1.800 tariffa di gruppo',
		charteredHelicopter: 'Elicottero a Noleggio',
		helicopterCostDesc: '+CHF 3.400 tariffa di gruppo fissa',
		culinaryPackageLevel: 'Livello Pacchetto Culinario e Dietetico',
		savannahClassic: 'Classico della Savana',
		gourmetDiningInc: 'Cena Gourmet (Inc)',
		bushVeganOrganic: 'Savana Vegana e Biologica',
		veganCostDesc: '+CHF 120 / giorno / persona',
		gourmetCellars: 'Cantine Gourmet',
		cellarCostDesc: '+CHF 180 / giorno / persona',
		coordinationDetailContact: 'Contatto per il Coordinamento',
		yourFullName: 'Il Tuo Nome Completo',
		yourEmail: 'La Tua Email',
		customNotesOrReminders: 'Note Personalizzate o Richieste Dietetiche/Mediche',
		submitPrivateInquiry: 'Invia Richiesta Privata',
		expeditionPendingConsultation: 'Spedizione in Attesa di Consultazione',
		trackingDetailsLogged: 'I dettagli del tracciamento sono stati registrati sulla nostra rete radio.',
		inquiryReferenceKey: 'Chiave di riferimento richiesta',
		estTotalSum: 'Somma totale stimata',
		preparatoryPdfRouted:
			'Un PDF preparatorio completo con vaccinazioni necessarie, collegamenti dei voli e requisiti di imballaggio è stato inviato a',
		safariPrepChecklist: 'La Tua Lista di Preparazione al Safari',
		checklistYellowFever: 'Assicurati una copia digitale ufficiale del certificato di febbre gialla',
		checklistDuffel: 'Acquista un bagaglio a sacco morbido (i telai rigidi sono vietati nelle cabine dei Cessna)',
		checklistClothing: 'Ordina abbigliamento da trekking nei toni neutri del kaki, verde o sabbia',
		returnToExploration: 'Torna all’Esplorazione',
		daysPrivateGuided: 'Giorni di Esperienza Guidata Privata',
		financialQuotation: 'Preventivo Finanziario',
		baseRate: 'Tariffa base',
		cessnaCommuterCharter: 'Charter Cessna Commuter',
		charteredHeliTransfer: 'Trasferimento in Elicottero Privato',
		vegetarianOrganicTier: 'Livello Vegetariano Biologico',
		gameCellarWinePackage: 'Pacchetto Vini e Selvaggina Gourmet',
		financialQuotationNotice:
			'• Include contributi per la conservazione della fauna selvatica, sistemazioni in tende premium a occupazione doppia e safari privati con veicolo 4x4.',
		estimatedPrivateTotal: 'Totale Privato Stimato',

		letsDesignExperience: 'Progettiamo la Tua Esperienza',
		contactIntroText:
			'Contattaci direttamente. Che tu abbia domande sugli itinerari locali, richieda tariffe riservate o desideri iniziare a pianificare il tuo safari su misura, il nostro team di esperti è a disposizione.',
		conciergeDesksText:
			'Operiamo sulla fiducia personale e su una profonda esperienza locale, gestendo itinerari di lusso personalizzati direttamente dai nostri uffici di pianificazione europei e sudafricani.',
		ourLocations: 'Le Nostre Sedi',
		switzerlandAndSouthAfrica: 'Svizzera e Sudafrica',
		directLine: 'Linea Diretta',
		instantWhatsAppChat: 'Chat WhatsApp Istantanea',
		connectWhatsAppText: 'Invia un messaggio diretto a Kyle e Rossella Blewitt.',
		openWhatsAppButton: 'Apri WhatsApp',
		officialCorrespondence: 'Corrispondenza Ufficiale',
		followOurJourneys: 'Segui i Nostri Viaggi',
		guaranteedResponseText: 'Risposta garantita entro un giorno lavorativo',
		inquiryForwarded: 'Richiesta Inoltrata',
		inquiryForwardedText:
			'Grazie per aver inviato i dettagli. Una copia è stata registrata e Rossella & Kyle Blewitt sono stati informati. Riceverai presto una proposta personalizzata nella tua casella di posta.',
		sendAnotherMessage: 'Invia un altro messaggio',
		conciergeMessageStream: 'Flusso Messaggi Concierge',
		conciergeMessageStreamText: 'Completa i campi sottostanti per trasmettere una proposta crittografata diretta.',
		fullName: 'Nome Completo',
		emailAddress: 'Indirizzo Email',
		contactPhoneLine: 'Linea Telefonica di Contatto',
		optionalLabel: '(Opzionale)',
		detailedInquiryMessage: 'Messaggio Dettagliato della Richiesta',
		transmittingCorrespondence: 'Trasmissione Corrispondenza...',
		transmitMessage: 'Trasmetti Messaggio',

		leadSafariPlanner: 'Pianificatore Safari Principale',
		sovereignEncryptionSecure: 'Criptografia Sovrana Sicura',
		welcomeMessage:
			'Jambo! Come possiamo trasformare i tuoi desideri in un itinerario nella savana africana? Indicami le date o il gruppo.',
		typicallyReplies: 'Linea Concierge • Di solito risponde in 5m',
		typeBespokeQuestDetail: 'Digita i dettagli della tua richiesta...',
		directWhatsAppInquire: 'Richiesta WhatsApp Diretta',
		safariPlannerOnline: 'Pianificatore Safari Online',
		promptText: 'Chatta dal vivo su WhatsApp con il nostro team!',

		homeTab: 'Home',
		safarisTab: 'Safari e Pacchetti',
		storyTab: 'La Nostra Storia',
		contactTab: 'Contattaci',
		requestAQuote: 'Richiedi un Preventivo',
		est2025Text: 'Fondato nel 2025 • Lusso e Natura',
		footerAboutText:
			'Fin dalla nostra fondazione, il nostro obiettivo è stato condividere la passione per la fauna africana e i viaggi, creando un’esperienza senza interruzioni ed arricchente che non dimenticherai mai. Una percentuale diretta dei proventi finanzia i ranger antibracconaggio e sostiene la conservazione locale.',
		followOurJourneysLabel: 'Segui i Nostri Viaggi:',
		fullyCertifiedASTA: 'Certificato interamente dalla African Sustainable Tourism Alliance.',
		termsAndConditions: 'Termini e Condizioni',
		privacyPolicy: 'Informativa sulla Privacy',
		indemnity: 'Indennità e Liberatoria',
		wildlifeBylaws: 'Termini e Condizioni',
		cessnaLuggageParameters: 'Informativa sulla Privacy',
		privacyCharter: 'Indennità e Liberatoria',

		filterCuratedRoutesDirectly: 'Filtra gli Itinerari Curati',
		customQuickSearch: 'Ricerca Rapida Personalizzata',
		featuredPrivateExpeditions: 'Prossime spedizioni',
		africanMasterpieces: 'Capolavori africani',
		exploreCuratedCollection: 'Esplora la collezione curata',
		craftBespokeMasterpiece: 'Non trovi l’itinerario adatto? Crea un Capolavoro su Misura.',
		tailoredWilderness: 'Natura Personalizzata',
		craftBespokeSubtitle:
			'Il nostro strumento interattivo ti permette di scegliere aree specifiche in tutto il Sudafrica, regolare il livello di lusso, selezionare le attività preferite e calcolare i costi stimati in tempo reale.',
		openBespokePlanner: 'Apri Bespoke Planner',
		safeguardingIvoryPathfinders: 'Salvaguardia della fauna selvatica sudafricana',
		ourHeritage: 'Il Nostro Patrimonio',
		conservationPartnerships: 'Programmi di Conservazione',
		safarisThatProtect: 'Esperienze che proteggono e conservano',
		safarisThatProtectDesc:
			'Scopri di più su queste associazioni che si propongono di proteggere e monitorare le specie a rischio di estinzione.',
		over240kContributed: 'Oltre CHF 240k Contribuiti',
		empoweringCommunityRangers: 'Sostegno ai ranger della comunità e ai team veterinari',
		lowImpactFootprints: 'Impronte a Basso Impatto',
		strictDoubleOccupancy: 'Limiti rigidi di doppia occupazione per ettaro',
		curatedSafariExpeditionsTitle: 'Spedizioni Safari Curate',
		curatedSafariExpeditionsDesc:
			'Private itineraries exploring highly concentrated sanctuaries with specialized aviation flights.',
		territoryLabel: 'Territorio: ',
		collectionLabel: 'Collezione: ',
		clearFilters: 'Azzera Filtri',
		noCustomMatches: 'Nessun Risultato Trovato',
		noCustomMatchesDesc:
			'Non abbiamo trovato safari che soddisfino entrambi i criteri. Modifica i filtri o usa il nostro pianificatore su misura qui sotto.',
		seeAllSafaris: 'Mostra Tutti i Safari',
		dreamingAviationRouting: 'Sogni un volo charter personalizzato?',
		dreamingAviationRoutingDesc:
			'Combina i parchi del Serengeti, il trekking con i gorilla in Ruanda e i canali del Botswana per ricevere preventivi immediati.',
		goToBespokePlanner: 'Vai al Bespoke Planner',
		designYourWildernessJourney: 'Disegna il Tuo Viaggio nella Natura',
		designYourWildernessJourneyDesc:
			'Pianifica il tuo safari privato, organizza i trasferimenti e ottieni preventivi rapidi per il tuo viaggio su misura.',
		curatedCustomWishlists: 'Liste dei desideri personalizzate',
		mySavedSafaris: 'I Miei Safari Salvati',
		mySavedSafarisDesc: 'Rivedi i tuoi viaggi preferiti o richiedi una consulenza diretta per la prenotazione.',
		noSafarisCached: 'Nessun Safari Salvato',
		noSafarisCachedDesc: 'Clicca sull’icona del cuore sulle schede dei safari per salvare le tue preferenze qui.',
		goToCuratedSafaris: 'Vai ai Safari Curati',
		myActiveInquiries: 'Le Mie Richieste Attive',
		loggedLabel: 'Registrato',
		bespokeDayArchitectJourney: 'Viaggio su Misura di {duration} Giorni',
		guestsLabel: 'Ospiti:',
		dateLabel: 'Data:',
		commuteColon: 'Trasporto:',
		culinaryColon: 'Cucina:',
		destinationsColon: 'Destinazioni:',
		tierLevelColon: 'Livello di Lusso:',
		reviewActiveStatus: 'Esamina stato attivo',
		closeInquiryPanel: 'Chiudi Pannello Richieste',

		packageOfInterest: 'Pacchetto di Interesse',
		preferredActivities: 'Attività Preferite',
		datesParameters: 'Date e Parametri',
		personalCredentials: 'Dati Personali',
		stageLabel: 'Fase',
		ofLabel: 'di',
		selectCoreExperienceStyle: 'Seleziona lo Stile dell’Esperienza',
		howWishToSleepCommute: 'Come Desideri Dormire e Viaggiare?',
		howWishToSleepCommuteDesc:
			'Identifica lo stile dell’alloggio e dei trasporti che meglio si adatta al tuo standard di viaggio.',
		exploreSpecializedActivities: 'Esplora Attività di Concessione Specializzate',
		whatCapturesImagination: 'Cosa Cattura la Tua Immaginazione?',
		whatCapturesImaginationDesc:
			'Seleziona le esperienze che ti interessano di più. Il nostro team utilizzerà le tue scelte per creare un viaggio su misura per te.',
		timelineBudgetGroupParams: 'Timeline, Budget e Parametri del Gruppo',
		expeditionDynamics: 'Dinamiche della Spedizione',
		expeditionDynamicsDesc: 'Specifica le dimensioni del gruppo, le preferenze di trasporto e le date previste.',
		dateFromWithAsterisk: 'Data Da *',
		dateToWithAsterisk: 'Data A *',
		howMuchToSpendWithAsterisk: 'Con quale budget vorresti che lavorassimo? *',
		typeOfGroup: 'Tipo di Gruppo',
		transportationChoice: 'Scelta del Trasporto',
		numberOfGuests: 'Numero di Ospiti',
		childrenAgesLabel: 'Età dei Bambini (Opzionale)',
		childrenAgesPlaceholder: 'es. 6, 11 (lasciare vuoto se solo adulti)',
		childrenAgesHelp:
			'Alcuni lodge, safari e attività prevedono limiti o raccomandazioni di età. Indicare l’età dei bambini ci assicura di selezionare le sistemazioni ed esperienze più adatte alla famiglia.',
		estimatedBlueprintBase: 'Stima Base dell’Itinerario',
		computedDuration: 'Durata Calcolata:',
		nightsFor: 'notti per',
		paxLabel: 'Persone',
		includesLeviesNotice: '*Include tasse di riserva, esclusi i voli',
		fullNameWithAsterisk: 'Nome Completo *',
		emailAddressWithAsterisk: 'Indirizzo Email *',
		phoneNumberWithAsterisk: 'Numero di Telefono *',
		whereDoYouLive: 'Dove Vivi? (Città e Nazione)',
		preferredDepartureAirport: 'Aeroporto di Partenza Preferito (Città)',
		wouldYouLikeFlightSuggestions: 'Desideri Suggerimenti per i Voli?',
		yesSendFlightIdeas: 'Sì, inviatemi idee di volo',
		noAlreadySorted: 'No, ho già provveduto',
		anySpecialRequestsOrPreferences: 'Richieste Speciali o Preferenze?',
		textareaSpecialRequestsPlaceholder:
			'Descrivi esigenze dietetiche, limiti di tracciamento, trasferimenti personalizzati, attrezzatura fotografica, ecc...',
		mandatoryCredentialsAlert:
			'Si prega di fornire tutti i dati obbligatori (Nome, Email e Telefono) per l’assegnazione di un pianificatore dedicato.',
		telemetrySecure: 'Dati Ricevuti',
		transmissionAlert: 'Avviso di Trasmissione',

		curatedMasterpieceTour: 'Tour Capolavoro Curato /',
		durationLabel: 'Durata',
		paceCategoryLabel: 'Categoria Ritmo',
		rateStartLabel: 'Prezzo a Partire Da',
		journeyOverview: 'Panoramica del Viaggio',
		wildLuxuryAccommodations: 'Alloggi di Lusso Selvaggio',
		dayByDayExperience: 'Esperienza Giorno per Giorno',
		selectDayBelow: 'L’itinerario sottostante è un esempio di ciò che puoi aspettarti…',
		dayItinerary: 'Itinerario Giorno {day}',
		dailyHighlightsEvents: 'Highlights e Attività del Giorno',
		premiumInclusions: 'Servizi Premium Inclusi',
		requiredPreparations: 'Preparativi Richiesti',
		checklistYellowFeverPrep: 'Certificato di febbre gialla valido e profilassi antimalarica',
		checklistLuggageLimit: 'Limite bagaglio morbido senza telaio rigido: 15kg',
		checklistVisaPrep: 'Visti d’ingresso predisposti 30 giorni prima della partenza',
		totalPrivateRate: 'Tariffa Privata Totale',
		inquireBookNow: 'Richiedi Informazioni e Prenota',
		daysLabel: 'Giorni',

		// Wizard Options
		styleLuxuryTitle: 'Soggiorno di Lusso',
		styleLuxuryDesc:
			'Soggiorna in lodge di lusso e riserve private accuratamente selezionati, che uniscono un comfort eccezionale, splendide posizioni ed esperienze safari indimenticabili.',
		styleLuxuryPrice: 'A partire da circa CHF 1.200/notte',
		styleBudgetTitle: 'Soggiorno Economico',
		styleBudgetDesc:
			'Goditi sistemazioni autentiche e confortevoli che offrono un eccellente rapporto qualità-prezzo, mantenendoti vicino alla fauna selvatica e alla bellezza naturale del Sudafrica.',
		styleBudgetPrice: 'A partire da circa CHF 350/notte',
		styleSelfDriveTitle: 'Tour Autoguidato (Self-Drive)',
		styleSelfDriveDesc:
			'Esplora il Sudafrica secondo i tuoi ritmi con un itinerario personalizzato, alloggi selezionati con cura e il nostro supporto continuo durante tutto il viaggio.',
		styleSelfDrivePrice: 'A partire da circa CHF 480/notte',
		styleBig5Title: 'Tour Safari Big 5',
		styleBig5Desc:
			"Vivi l'emozione di safari con guide esperte in alcune delle migliori riserve faunistiche del Sudafrica, con l'opportunità di incontrare gli iconici Big Five e molto altro.",
		styleBig5Price: 'A partire da circa CHF 850/notte',
		stylePersonalisedTitle: 'Pacchetto Personalizzato',
		stylePersonalisedDesc:
			'Un viaggio completamente su misura creato intorno a te — unendo le tue destinazioni preferite, alloggi, attività e stile di viaggio in un itinerario perfetto.',
		stylePersonalisedPrice: 'Prezzo su misura',
		styleSustainableTitle: 'Interazioni Sostenibili e Conservazione',
		styleSustainableDesc:
			"Scopri il lavoro di conservazione dietro al tuo safari attraverso esperienze faunistiche etiche, iniziative di tutela e l'opportunità di imparare direttamente da chi protegge la fauna sudafricana.",
		styleSustainablePrice: 'A partire da circa CHF 650/notte',

		interestBig5Title: 'Avvistamento Big 5',
		interestBig5Label: 'Safari Classici in Fuoristrada',
		interestBig5Desc:
			"Vivi incontri indimenticabili con la fauna selvatica durante i safari guidati, con l'opportunità di ammirare i Big Five e la straordinaria varietà di animali che il Sudafrica ha da offrire.",
		interestSportsTitle: 'Sport ed Esperienze Attive',
		interestSportsLabel: "Avventura all'Aperto",
		interestSportsDesc:
			"Aggiungi avventura al tuo viaggio con attività come escursionismo, ciclismo, golf, passeggiate a cavallo e altre esperienze all'aperto scelte in base ai tuoi interessi.",
		interestOceanTitle: 'Esperienze Oceaniche',
		interestOceanLabel: 'Costiero e Marino',
		interestOceanDesc:
			'Esplora la costa sudafricana con esperienze che includono immersioni, avvistamento balene, incontri con le tartarughe, surf, pesca e altre attività marine.',
		interestScenicTitle: 'Voli Panoramici',
		interestScenicLabel: 'Voli a Bassa Quota',
		interestScenicDesc:
			'Guarda il Sudafrica da una prospettiva diversa con voli panoramici su coste spettacolari, montagne, riserve naturali e paesaggi mozzafiato.',
		interestConservationTitle: 'Conservazione Sostenibile',
		interestConservationLabel: "Sostenibilità dell'Ecosistema",
		interestConservationDesc:
			"Comprendi a fondo la protezione della fauna selvatica attraverso esperienze etiche di conservazione, attività educative e l'opportunità di scoprire il lavoro svolto sul campo.",
		interestCulinaryTitle: 'Esperienza Culinaria',
		interestCulinaryLabel: 'Cucina raffinata e Vini',
		interestCulinaryDesc:
			"Scopri il Sudafrica attraverso il suo cibo e i suoi vini, dai sapori tradizionali locali e le visite nei vigneti fino a ristoranti d'eccellenza e memorabili cene nella savana.",
		interestPhotographyTitle: 'Fotografia Naturalistica',
		interestPhotographyLabel: 'Masterclass di Fotografia',
		interestPhotographyDesc:
			'Voli fotografici senza portiere, stabilizzatori speciali per obiettivi e fotografi professionisti al tuo fianco.',

		groupCouple: 'Coppia',
		groupFamily: 'Famiglia',
		groupSolo: 'Viaggiatore Singolo',
		groupFriends: 'Gruppo di Amici',
		groupOther: 'Altro',

		transportOrganised: 'Trasporto Organizzato',
		transportSelfDrive: 'Autoguidato (Self-drive)',
		transSelfDriving: 'Autoguidato (Self-drive)',
		transOrganised: 'Trasporto Organizzato',

		wizardSuccessSecure: 'Proposta Registrata con Sicurezza',
		wizardSuccessDesc:
			'I codici di tracciamento della concessione sovrana e i permessi di volo sono pre-riservati nei registri locali.',
		wizardSuccessPlanner: 'Pianificatore di Viaggio:',
		wizardSuccessCredentials: 'Credenziali Inviate a:',
		wizardSuccessDuration: 'Durata Pianificata:',
		wizardSuccessNights: 'Notti (Scorta privata garantita)',
		wizardSuccessGroup: 'Posti del Gruppo:',
		wizardSuccessSecondary: 'Disegna un Secondo Itinerario',
		wizardSuccessUnlock: 'Inviando la richiesta ti metterai in contatto diretto con il nostro team di esperti safari.',
		wizardPrev: 'Indietro',
		wizardNext: 'Avanti',
		wizardSubmit: 'Invia Richiesta di Preventivo',
		wizardSubmitting: 'Trasmissione Proposta...',
		wizardAssignedId: 'ID Concessione Assegnato',
		recommendedLevel: 'Livello Consigliato',

		// Testimonials / Guest Reviews / Guarantees
		simplifyingJourneyTitle: 'Semplificare il Tuo Viaggio Perfetto',
		simplifyingJourneyDesc1:
			'I nostri pacchetti di viaggio semplificano il processo di prenotazione rispondendo a tutti i tipi di interessi e budget. Copriamo ogni aspetto del tuo viaggio, come alloggio, attività e trasferimenti.',
		simplifyingJourneyDesc2:
			'Vogliamo che tu ottenga il massimo dal tuo viaggio, assicurandoti che sia un’esperienza meravigliosa che',
		guestChronicles: 'Recensioni degli ospiti',
		guestChroniclesDesc: 'Esperienze reali: sono i nostri ospiti a raccontarlo meglio.',
		selectSafariStory: 'Seleziona una Storia di Safari',
		verifiedAdventurer: 'Avventuriero Verificato • {location}',
		prevReview: 'Recensione Precedente',
		nextReview: 'Recensione Successiva',

		// Testimonial Specific Metadata (leaving quotes in english)
		tripBespokeSelfDrive: 'Spedizione Self-Drive su Misura',
		tripCuratedWilderness: 'Safari Curato nella Natura',
		tripUltraLuxuryAir: 'Volo Charter Privato di Ultra-Lusso',
		highlightFlexibility: 'Flessibilità, Serenità Remota e Incontri alla Pozza d’Acqua',
		highlightMagical: 'Incontri Magici con Animali e Spettacolari Safari Notturni',
		highlightIncomparable: 'Lusso Incomparabile e Armonia con la Natura',
		destTalamati: 'Parco Nazionale Kruger (Talamati Bushveld Camp)',
		destLionReserves: 'Parco Nazionale Kruger e Riserve dei Leoni',
		destSandibe: 'Delta dell’Okavango (Riserva Privata di Sandibe)',

		// Travel Styles UI
		readNarrative: 'Leggi la Narrazione',
		hideNarrative: 'Nascondi Narrazione',
		discoverOurPackages: 'Scopri i Nostri Pacchetti',
		pristineHighlights: 'Momenti Salienti Inclusi',
		startFrom: 'A partire da',
		ourServicesTab: 'I Nostri Servizi e Stili di Viaggio',
		seamlessEnrichingTitle: 'Safari Fluidi e Arricchenti',
		seamlessEnrichingSubtitle1:
			'Il nostro obiettivo presso Elephant Expeditions è condividere la nostra passione per gli animali africani e i viaggi con voi creando un’esperienza di viaggio fluida e arricchente che non dimenticherete mai.',
		seamlessEnrichingSubtitle2:
			'Su misura per singoli, famiglie e gruppi provenienti dall’Europa e da tutto il mondo, il nostro pubblico di riferimento è interessato a esplorare la ricca fauna selvatica e la bellezza naturale del Sudafrica.',

		// Travel Styles Content Italian
		style_luxury_title: 'Soggiorni di Lusso',
		style_luxury_subtitle: 'Sistemazioni esclusive in lodge di alto livello e riserve private.',
		style_luxury_desc:
			'Immergiti in un santuario di assoluta tranquillità. Alloggia in sistemazioni esclusive in lodge di alto livello e riserve private progettate nei minimi dettagli per combinare il lusso degli standard europei con un accesso diretto e ininterrotto alla natura.',
		style_luxury_h1: 'Sistemazioni esclusive in lodge di alto livello e riserve private.',
		style_luxury_h2: 'Tour guidati per osservare gli animali in riserve esclusive.',
		style_luxury_h3: 'Servizi premium come trattamenti spa e itinerari personalizzati.',
		style_luxury_eco: 'Alleanza Eco-Luxe Oro',

		style_budget_title: 'Soggiorni Economici',
		style_budget_subtitle: 'Opzioni più accessibili senza scendere a compromessi sull’esperienza.',
		style_budget_desc:
			'Vivi la magia della foresta africana da vicino con un budget più accessibile. Alloggia in lodge e pensioni affascinanti che danno priorità al comfort, al calore e all’autenticità.',
		style_budget_h1: 'Opzioni più accessibili senza scendere a compromessi sull’esperienza.',
		style_budget_h2: 'Sistemazioni eccezionali, inclusi lodge e pensioni che offrono comfort e qualità.',
		style_budget_h3: 'Safari con tour guidati, opzioni convenienti con piani all-inclusive o self-catering.',
		style_budget_eco: 'Standard Verde a Basso Impatto',

		style_selfdrive_title: 'Tour Self-Drive',
		style_selfdrive_subtitle: 'Per viaggiatori avventurosi che preferiscono guidare da soli.',
		style_selfdrive_desc:
			'La via definitiva per una scoperta personale e non scritta. Forniamo itinerari perfettamente pianificati, percorsi consigliati, alloggi e attività premium prenotati in anticipo per garantirti un safari self-drive senza stress.',
		style_selfdrive_h1: 'Itinerari ben pianificati, percorsi consigliati e alloggi prenotati in anticipo.',
		style_selfdrive_h2: 'Suggerimenti per il noleggio auto.',
		style_selfdrive_h3: 'Suggerimenti per navigare sul terreno ed esplorare le regioni al proprio ritmo ideale.',
		style_selfdrive_eco: 'Compensazione delle Emissioni di Carbonio del Percorso',

		style_big5_title: 'Safari dei Big 5',
		style_big5_subtitle: 'Safari su misura incentrati sull’avvistamento dei leggendari Big 5.',
		style_big5_desc:
			'Safari dedicati e curati per aiutarti ad avvistare i leggendari Big 5: leone, leopardo, elefante, rinoceronte e bufalo. Goditi le escursioni guidate condotte dai migliori specialisti del tracciamento nei parchi nazionali più spettacolari del Sud Africa.',
		style_big5_h1:
			'Safari su misura incentrati sull’avvistamento dei Big 5 (leone, leopardo, elefante, rinoceronte e bufalo).',
		style_big5_h2: 'Focus sugli animali "Big 5" con tour guidati in riserve e parchi nazionali spettacolari.',
		style_big5_h3: 'Straordinarie opportunità di tracciamento, fotografia ed esperienze educative nella natura.',
		style_big5_eco: 'Sussidi del Fondo di Supporto per i Ranger',

		style_personalized_title: 'Pacchetti Personalizzati',
		style_personalized_subtitle: 'Molto più di un semplice safari. Creato su misura per te.',
		style_personalized_desc:
			'Progetti personalizzati realizzati per catturare la tua definizione personale di avventura selvaggia. Assapora il vero sapore dell’Africa, sia che tu cerchi la fauna incontaminata, i panorami mozzafiato, la cucina raffinata o profonde connessioni culturali.',
		style_personalized_h1:
			'Su misura per le tue preferenze: fauna selvatica, paesaggi suggestivi, vita da spiaggia, esperienze culinarie o culturali.',
		style_personalized_h2:
			'Attività come voli panoramici, crociere con ippopotami, avvistamento balene e pesca d’altura.',
		style_personalized_h3: 'Possibility of professional photographic guide accompaniment to capture your journey.',
		style_personalized_eco: 'Salari Diretti alle Comunità Locali',

		style_sustainable_title: 'Interazioni Sostenibili',
		style_sustainable_subtitle: 'Esperienze di conservazione. Immergiti negli sforzi per preservare la fauna.',
		style_sustainable_tag: 'Custodia Attiva',
		style_sustainable_desc:
			'Immergiti profondamente negli sforzi attivi di conservazione. Partecipa a progetti di tutela della fauna selvatica che offrono una comprensione profonda degli impegni di conservazione in Sud Africa.',
		style_sustainable_h1: 'Esperienze pratiche per comprendere a fondo la tutela della fauna africana.',
		style_sustainable_h2:
			'Può includere la partecipazione alle attività di rimozione del corno dei rinoceronti, monitoraggio o passeggiate con i pangolini.',
		style_sustainable_h3: 'Interazioni sostenibili come incontri con elefanti nel rispetto del loro benessere.',
		style_sustainable_eco: 'Approvata la Certificazione 100% Etica',
	},
	fr: {
		// Header
		discover: 'Découvrir',
		curatedSafaris: "Safaris d'Exception",
		bespokePlanner: 'Planificateur Sur Mesure',
		designBespoke: 'Créer Sur Mesure',
		inquiries: 'Demandes',
		savedSafaris: 'Safaris Enregistrés',
		allTerritories: 'Tous les Territoires',
		allCollections: 'Toutes les Collections',
		selectDest: 'Choisir une Destination',
		selectExp: 'Choisir une Expérience',
		ourStoryTab: 'Notre Histoire',
		contactUsTab: 'Contactez-nous',
		savedTab: 'Enregistrés',

		// Hero Section
		wildMeetsExquisite: "Une Expérience Sauvage que Vous N'Oublierez Jamais",
		discoverSouthAfrica: "Découvrez l'Afrique du Sud",
		heroSubtitle:
			"Chez Elephant Expeditions, notre objectif est de partager notre passion pour les animaux d’Afrique et le voyage à travers une expérience fluide et enrichissante que vous N'OUBLIEREZ JAMAIS ! Explorez les plus prestigieux lodges de luxe d'Afrique du Sud, des séjours de charme, des circuits en liberté et de spectaculaires safaris à la recherche des Big 5.",
		neverForget: "N'OUBLIEZ JAMAIS !",
		curatedTravelStyles: 'Styles de Voyage Sur Mesure',
		ethcialSafaris: 'Safaris 100 % éthiques',
		conservationFocused: 'Axé à 100 % sur la conservation',
		authenticExperiences: 'Expériences authentiques',
		territoryPatrolStatus: 'Statut des patrouilles actives',
		secureSabiSands: '● SÉCURISÉ - RÉSERVES DE SABI SANDS',
		krugerActivityEstimate: 'Activité faunique estimée au Kruger',
		highDensityHerdTracking: 'Suivi des Troupeaux à Haute Densité',
		satelliteRelayOnline: 'Relais satellite en ligne',
		capeTownHqSync: 'Liaison synchronisée avec le QG du Cap',
		heroBadge: 'Conservation Biologique',

		// Grid and Cards
		difficultyRelaxed: 'Paisible',
		difficultyModerate: 'Modéré',
		difficultyActive: 'Actif',
		bespokeTitle: 'Itinéraire Sur Mesure / Personnalisé',
		bespokeLocation: 'Destinations Africaines Sur Mesure',
		bespokeDesc: 'Concevez un itinéraire entièrement personnalisé en Afrique du Sud avec notre équipe.',
		days: 'jours',
		fromPrice: 'À partir de',
		perPerson: 'par personne',
		reviews: 'avis',
		featured: 'Recommandé',
		saveToInquiry: 'Ajouter à la Demande',
		saved: 'Enregistré',
		viewItinerary: "Voir l'Itinéraire",
		bookExpedition: "Réserver l'Expédition",
		noResults: 'Aucun résultat trouvé. Élargissez vos coordonnées géographiques.',

		// Our Story Section
		aboutUsHeader: 'Un Héritage Écrit dans la Poussière',
		aboutUsTitlePart1: 'Notre histoire, ',
		aboutUsTitlePart2: 'Notre passion.',
		aboutParagraph1:
			"Basée en Suisse, Elephant Expeditions est née de la passion commune de Kyle et Rossella Blewitt pour l'Afrique, sa faune exceptionnelle et ses paysages préservés. Ensemble, Kyle et Rossella ont fondé Elephant Expeditions sur les piliers de la conservation de la faune, du tourisme éthique et d'expériences authentiques pour leurs hôtes. Ils sont convaincus que chaque safari doit non seulement être inoubliable, mais également contribuer activement à la préservation du patrimoine naturel africain. En collaborant avec les communautés locales et des projets de conservation, Elephant Expeditions veille à ce que chaque voyage soutienne des pratiques durables et favorise une compréhension intime des écosystèmes uniques du continent.",
		aboutParagraph2:
			"Chez Elephant Expeditions, les voyageurs sont invités à explorer les paysages majestueux d’Afrique et à rencontrer sa faune extraordinaire grâce à des itinéraires minutieusement conçus dans le plus grand respect de l’environnement. Que vous optiez pour un séjour de grand luxe, une aventure en autonomie ou un safari photographique, l'engagement de Kyle et Rossella envers l'authenticité et la conservation garantit une expérience profonde, mémorable et que vous n'oublierez jamais.",
		foundingYearLabel: 'Année de Fondation',
		ethicalLabel: 'Éthique',
		personalLabel: 'PERSONNEL',
		personalLabelDesc: 'du début à la fin',
		foundersTitle: 'Rencontrez les Fondateurs',
		foundersTitleDesc:
			'Elephant Expeditions est née de la rencontre entre la nature sauvage africaine et les exigences rigoureuses du luxe européen. Unies par une passion commune pour les grands espaces, Kyle et Rossella pilotent depuis la Suisse la conception de chaque safari sur mesure.',
		founderKyleTitle: 'Co-Fondateur / Aventurier & Photographe',
		founderKyleBio:
			'Le parcours de Kyle Blewitt se lit comme un roman d’aventure. Pilote depuis l’âge de 15 ans, Kyle a passé des années à survoler certains des paysages les plus époustouflants au monde, des vastes savanes africaines aux terrains accidentés de l’Inde, en passant par les eaux cristallines des Seychelles. Sa carrière l’a conduit à effectuer aussi bien des missions d’évacuation sanitaire et de transport de fret dans des régions isolées qu’à piloter des jets privés à travers l’Europe, l’Afrique du Nord et l’Asie. Pourtant, où qu’il aille, son cœur le ramène toujours vers la brousse africaine.',
		founderKyleBio2:
			'Ayant grandi en Afrique du Sud, Kyle a été immergé dans la nature sauvage dès son plus jeune âge, où il a développé un profond respect pour les animaux et les écosystèmes africains. Il a passé son enfance à pratiquer la pêche sous-marine, la pêche et à découvrir les riches subtilités de la faune et de la flore africaines. Au fil du temps, il a cultivé une compréhension approfondie de l’équilibre délicat entre l’activité humaine et la conservation de la faune, ce qui est devenu un principe directeur dans son travail.',
		founderKyleBio3:
			'Aujourd’hui installé en Suisse, Kyle a ressenti le besoin de partager son amour pour les paysages africains, leur beauté sauvage et leur faune diversifiée avec les autres. Fonder Elephant Expeditions était pour lui une manière de “rentrer chez lui” en Afrique tout en offrant aux voyageurs l’opportunité de vivre la magie qu’il a toujours connue.',
		founderRossellaTitle: 'Co-Fondatrice / Educatrice & Conservatrice',
		founderRossellaBio:
			"Le parcours de Rossella Blewitt est placé sous le signe de l'exploration, de l'éducation et d'une profonde passion pour les animaux. Née et élevée en Suisse, elle enseigne l'anglais dans le canton du Tessin. Son cursus universitaire l'a conduite au Royaume-Uni, en Islande et en Italie, tandis que de nombreux voyages à travers le monde ont élargi ses horizons.",
		founderRossellaBio2:
			"Sa vie a pris un tournant inattendu et magnifique lorsqu'elle s'est portée volontaire pour un programme de l'organisation Wildlife ACT, participant à la recherche et au suivi d'espèces menacées en Afrique du Sud. C'est là qu'elle a rencontré Kyle — aujourd'hui son mari et cofondateur d'Elephant Expeditions — et qu'elle est tombée amoureuse non seulement de lui, mais aussi du continent africain.",
		founderRossellaBio3:
			'Depuis lors, le lien qui unit Rossella à l’Afrique n’a cessé de se renforcer. Elle a vécu l’expérience unique de pister des pangolins dans des réserves abritant les « Big Five » et continue de parcourir l’Afrique du Sud, tout en suivant des formations pour approfondir ses connaissances. Sa passion pour la faune sauvage africaine et sa préservation la pousse à enrichir sans cesse son savoir sur la flore et la faune du continent.',
		founderRossellaBio4:
			"La combinaison de connaissances académiques et d'expérience pratique dans la nature sauvage permet à Rossella de se connecter avec les voyageurs, leur offrant une perspective authentique sur la faune et la culture africaines. Avec Kyle, elle apporte passion, savoir et dévouement à Elephant Expeditions, créant des safaris inoubliables.",
		coreCommitmentsTitle: 'Notre Engagement pour un Safari Éthique',
		coreCommitmentsSubtitle:
			'Chez Elephant Expeditions, nous croyons qu’un safari d’exception doit avoir un impact positif sur la faune, les espaces sauvages et les communautés qui le rendent possible.',
		pillarAntiPoachingTitle: 'Soutien à la Conservation',
		pillarAntiPoachingDesc:
			'Nous sélectionnons avec soin les lodges, réserves et expériences qui contribuent activement à la protection de la faune et à la préservation des habitats naturels. En voyageant avec nous, nos voyageurs soutiennent la conservation grâce à un tourisme responsable.',
		pillarCommunityTitle: 'Voyage Responsable & Éthique',
		pillarCommunityDesc:
			'Le bien-être animal et l’observation respectueuse de la faune sont au cœur des safaris que nous créons. Nous privilégions les partenaires éthiques et les expériences qui respectent les animaux et leur permettent de rester véritablement sauvages.',
		pillarSovereignTrustTitle: 'Connecter les Voyageurs à la Conservation',
		pillarSovereignTrustDesc:
			'Nous sommes convaincus qu’un safari est plus enrichissant lorsque l’on comprend ce que l’on observe. Nous aidons nos voyageurs à découvrir la faune, les écosystèmes et les enjeux de conservation, forgeant ainsi un lien profond avec l’Afrique du Sud et son patrimoine naturel.',
		impactTitle: "Calculateur d'Impact de Conservation en Temps Réel",
		impactSubtitle:
			'Indiquez votre budget estimé pour visualiser votre contribution directe aux actions de conservation locales.',
		investmentLabel: "Budget Estimé de l'Expédition (CHF)",
		calculatedImpact: 'Contribution Directe Estimée',
		antiPoachingPatrols: 'Patrouilles Anti-Braconnage',
		antiPoachingDesc:
			'Heures de patrouilles entièrement financées avec rangers équipés de radios et traceurs optiques.',
		co2Reduction: 'Préservation du Carbone et des Habitats',
		co2Desc: 'Tonnes de biomasse et puits de carbone protégés grâce à la préservation de la savane.',
		protectedAcres: 'Superficie Sauvage Protégée',
		protectedDesc: 'Hectares de nature sauvage sous surveillance permanente de patrouilles dédiées.',
		schoolMaterialWeeks: 'Soutien Scolaire Communautaire',
		schoolDesc: 'Semaines de matériel éducatif fournies aux enfants des communautés environnantes.',

		// Itinerary Drawer
		overviewTab: 'Aperçu',
		detailedItineraryTab: 'Itinéraire Détaillé',
		accommodationsInclusionsTab: 'Hébergements & Inclusions',
		closeButton: 'Fermer',
		highlightsHeader: 'Points Forts',
		accommodationsHeader: 'Hébergements',
		inclusionsHeader: 'Prestations Incluses',
		dayLabel: 'Jour',

		// Booking & Quote Wizard
		bespokeTripPlanner: "Planificateur d'Expédition Sur Mesure",
		designBespokeTitle: 'Votre Voyage Personnalisé',
		wizardStep1Title: 'Choisissez Votre Destination',
		wizardStep1Desc: 'Sélectionnez les sanctuaires naturels que vous souhaitez parcourir.',
		wizardStep2Title: "Style d'Hébergement",
		wizardStep2Desc: "Choisissez l'ambiance et le niveau de confort de vos camps.",
		wizardStep3Title: 'Engagement Conservation',
		wizardStep3Desc: 'Allouez un pourcentage de votre réservation à des actions directes sur le terrain.',
		wizardStep4Title: "Détails de l'Expédition",
		wizardStep4Desc: 'Logistique, transferts et préférences gastronomiques dans la savane.',
		wizardStep5Title: 'Coordonnées de Contact',
		wizardStep5Desc:
			'Notre équipe utilisera vos préférences pour concevoir un voyage sur mesure en Afrique du Sud, créé spécialement pour vous.',
		nextStep: 'Étape Suivante',
		prevStep: 'Étape Précédente',
		submitting: 'Transmission aux Rangers...',
		submitInquiry: 'Envoyer la Demande Sur Mesure',
		successTitle: 'Demande Transmise avec Succès',
		successDesc:
			'Votre demande a été transmise à nos équipes de Sabi Sands et du Cap. Un créateur de voyage dédié vous contactera sous 24 heures avec votre itinéraire interactif.',

		// Extra UI Keys
		reservationDesk: 'Bureau des Réservations',
		desiredDepartureDate: 'Date de Départ Souhaitée',
		travelerCount: 'Nombre de Voyageurs',
		guest: 'Voyageur',
		guests: 'Voyageurs',
		aviationUpgrade: 'Option Transfert Aérien Privé',
		standardBushRun: 'Vol Régulier de Brousse',
		includedInBase: 'Inclus dans le tarif de base',
		privateCessnaCaravan: 'Cessna Caravan Privatisé',
		cessnaCostDesc: '+CHF 1 800 par groupe',
		charteredHelicopter: 'Hélicoptère Privatif',
		helicopterCostDesc: '+CHF 3 400 tarif forfaitaire groupe',
		culinaryPackageLevel: 'Formule Gastronomique & Régimes',
		savannahClassic: 'Classique Savane',
		gourmetDiningInc: 'Haute cuisine (Inclus)',
		bushVeganOrganic: 'Végétalien & Bio de Brousse',
		veganCostDesc: '+CHF 120 / jour / personne',
		gourmetCellars: 'Grands Crus & Vins Rares',
		cellarCostDesc: '+CHF 180 / jour / personne',
		coordinationDetailContact: 'Coordonnées de Contact',
		yourFullName: 'Votre Nom Complet',
		yourEmail: 'Votre Adresse E-mail',
		customNotesOrReminders: 'Notes Particulières, Régimes ou Remarques Médicales',
		submitPrivateInquiry: 'Envoyer la Demande Privée',
		expeditionPendingConsultation: "Expédition en Cours d'Étude",
		trackingDetailsLogged: 'Vos coordonnées ont été enregistrées sur notre réseau de transmission.',
		inquiryReferenceKey: 'Référence de la demande',
		estTotalSum: 'Montant total estimé',
		preparatoryPdfRouted:
			'Un guide préparatoire complet détaillant les vaccins, les correspondances aériennes et les conseils pour vos bagages a été envoyé à',
		safariPrepChecklist: 'Votre Liste de Préparation au Safari',
		checklistYellowFever: "Disposer d'un certificat de vaccination contre la fièvre jaune",
		checklistDuffel: 'Prévoir un sac de voyage souple (les valises rigides sont interdites dans les Cessna de brousse)',
		checklistClothing: 'Prévoir des vêtements de terrain aux tons neutres (kaki, beige ou sable)',
		returnToExploration: 'Retour à la Découverte',
		daysPrivateGuided: "Jours d'Expérience Guidée Privative",
		financialQuotation: 'Devis Estimatif',
		baseRate: 'Tarif de base',
		cessnaCommuterCharter: 'Vol Privé Cessna',
		charteredHeliTransfer: 'Transfert Hélicoptère Privatif',
		vegetarianOrganicTier: 'Formule Végétarienne & Bio',
		gameCellarWinePackage: 'Sélection Vins Fins & Réserve',
		financialQuotationNotice:
			"• Comprend la contribution complète à la préservation de la faune, l'hébergement en tente de luxe double et les sorties privatives en 4x4.",
		estimatedPrivateTotal: 'Total Estimé Privatif',

		letsDesignExperience: 'Concevons Votre Expérience',
		contactIntroText:
			"Contactez-nous directement. Que vous ayez des questions d'itinéraire, souhaitiez un devis privé ou désiriez esquisser dès maintenant votre expédition africaine, notre équipe d'experts est à votre entière disposition.",
		conciergeDesksText:
			'Nous bâtissons notre relation sur la confiance et une expertise régionale sans compromis, orchestrant vos séjours de luxe depuis nos bureaux suisses et nos bases sud-africaines.',
		ourLocations: 'Nos Implantations',
		switzerlandAndSouthAfrica: 'Suisse & Afrique du Sud',
		directLine: 'Ligne Directe',
		instantWhatsAppChat: 'Discussion Directe WhatsApp',
		connectWhatsAppText: 'Échangez directement avec Kyle et Rossella Blewitt.',
		openWhatsAppButton: 'Ouvrir WhatsApp',
		officialCorrespondence: 'Correspondance Officielle',
		followOurJourneys: 'Suivez Nos Voyages',
		guaranteedResponseText: 'Guaranteed response in 1 business day',
		inquiryForwarded: 'Demande Transmise',
		inquiryForwardedText:
			'Merci pour votre transmission. Vos informations ont été enregistrées et transmises à Rossella & Kyle Blewitt. Vous recevrez très rapidement une proposition sur mesure dans votre boîte de réception.',
		sendAnotherMessage: 'Envoyer un Autre Message',
		conciergeMessageStream: 'Formulaire de Conciergerie',
		conciergeMessageStreamText:
			'Remplissez les champs ci-dessous pour nous transmettre directement votre demande de projet.',
		fullName: 'Nom Complet',
		emailAddress: 'Adresse E-mail',
		contactPhoneLine: 'Numéro de Téléphone',
		optionalLabel: '(Optionnel)',
		detailedInquiryMessage: 'Votre Message ou Projet',
		transmittingCorrespondence: 'Transmission du Message...',
		transmitMessage: 'Envoyer le Message',

		leadSafariPlanner: 'Responsable des Safaris',
		sovereignEncryptionSecure: 'Connexion Sécurisée Souveraine',
		welcomeMessage:
			'Jambo ! Comment pouvons-nous concevoir votre séjour dans la savane africaine ? Faites-moi part de vos dates et souhaits.',
		typicallyReplies: 'Conciergerie • Répond habituellement en 5 min',
		typeBespokeQuestDetail: 'Écrivez votre message ici...',
		directWhatsAppInquire: 'Contact Direct par WhatsApp',
		safariPlannerOnline: 'Conseillère Safari en Ligne',
		promptText: 'Échangez en direct sur WhatsApp avec notre équipe !',

		homeTab: 'Accueil',
		safarisTab: 'Safaris & Séjours',
		storyTab: 'Notre Histoire',
		contactTab: 'Contact',
		requestAQuote: 'Demander un Devis',
		est2025Text: 'Fondé en 2025 • Luxe & Grands Espaces',
		footerAboutText:
			"Depuis notre fondation, notre mission est de partager avec vous notre passion pour la faune africaine et le voyage en créant une expérience fluide et enrichissante que vous n'oublierez jamais. Une part directe de nos bénéfices finance les salaires des rangers locaux de lutte anti-braconnage et soutient les efforts essentiels de préservation.",
		followOurJourneysLabel: 'Suivez Nos Aventures :',
		fullyCertifiedASTA: "Certifié par l'Alliance Africaine pour le Tourisme Durable.",
		termsAndConditions: 'Conditions Générales',
		privacyPolicy: 'Politique de Confidentialité',
		indemnity: 'Indemnité & Décharge',
		wildlifeBylaws: 'Conditions Générales',
		cessnaLuggageParameters: 'Politique de Confidentialité',
		privacyCharter: 'Indemnité & Décharge',

		filterCuratedRoutesDirectly: "Filtrer les Itinéraires d'Exception",
		customQuickSearch: 'Recherche Rapide',
		featuredPrivateExpeditions: 'Expéditions à venir',
		africanMasterpieces: "Joyaux d'Afrique",
		exploreCuratedCollection: 'Explorer la collection',
		craftBespokeMasterpiece: "Vous recherchez un itinéraire unique ? Créez votre chef-d'œuvre sur mesure.",
		tailoredWilderness: 'La Nature Sur Mesure',
		craftBespokeSubtitle:
			"Notre outil de planification interactif vous permet de choisir des zones spécifiques en Afrique du Sud, d'ajuster les niveaux de luxe, de sélectionner vos activités privilégiées et de calculer les coûts estimés en temps réel.",
		openBespokePlanner: 'Ouvrir le Planificateur Sur Mesure',
		safeguardingIvoryPathfinders: "Préserver la faune sauvage d'Afrique du Sud",
		ourHeritage: 'Notre Héritage',
		conservationPartnerships: 'Programmes de Conservation',
		safarisThatProtect: 'Des expériences qui protègent et préservent',
		safarisThatProtectDesc:
			'Veuillez en savoir plus sur ces associations qui visent à protéger et à surveiller les espèces menacées.',
		over240kContributed: 'Plus de 240 000 CHF Reversés',
		empoweringCommunityRangers: 'Soutien aux rangers locaux et équipes vétérinaires',
		lowImpactFootprints: 'Empreinte Écologique Minimale',
		strictDoubleOccupancy: 'Limitation stricte des visiteurs par hectare',
		curatedSafariExpeditionsTitle: "Safaris & Expéditions d'Exception",
		curatedSafariExpeditionsDesc:
			'Des itinéraires privatifs explorant des sanctuaires sauvages uniques avec transferts aériens dédiés.',
		territoryLabel: 'Territoire : ',
		collectionLabel: 'Collection : ',
		clearFilters: 'Réinitialiser les Filtres',
		noCustomMatches: 'Aucun Résultat Trouvé',
		noCustomMatchesDesc:
			"Aucun safari ne correspond à l'ensemble de vos critères. Essayez d'ajuster vos filtres ou utilisez notre planificateur sur mesure.",
		seeAllSafaris: 'Voir Tous les Safaris',
		dreamingAviationRouting: "Vous rêvez d'un plan de vol sur mesure ?",
		dreamingAviationRoutingDesc:
			'Associez les plaines du Serengeti, les gorilles du Rwanda et les méandres du Botswana dans notre planificateur pour obtenir un devis rapide.',
		goToBespokePlanner: 'Accéder au Planificateur Sur Mesure',
		designYourWildernessJourney: 'Concevez Votre Voyage Sauvage',
		designYourWildernessJourneyDesc:
			'Concevez votre safari privé, planifiez vos transferts et obtenez une estimation rapide pour votre séjour sur mesure en Afrique.',
		curatedCustomWishlists: 'Sélections personnalisées',
		mySavedSafaris: 'Mes Safaris Enregistrés',
		mySavedSafarisDesc:
			'Retrouvez vos aventures favorites ou échangez avec un conseiller pour finaliser votre réservation.',
		noSafarisCached: 'Aucun Safari Enregistré',
		noSafarisCachedDesc: "Cliquez sur le cœur d'un safari lors de votre visite pour l'enregistrer ici.",
		goToCuratedSafaris: 'Découvrir les Safaris',
		myActiveInquiries: 'Mes Demandes Actives',
		loggedLabel: 'Enregistré',
		bespokeDayArchitectJourney: 'Séjour Sur Mesure de {duration} Jours',
		guestsLabel: 'Voyageurs :',
		dateLabel: 'Date :',
		commuteColon: 'Transferts :',
		culinaryColon: 'Gastronomie :',
		destinationsColon: 'Destinations :',
		tierLevelColon: 'Catégorie :',
		reviewActiveStatus: 'Consulter',
		closeInquiryPanel: 'Fermer le Panneau',

		packageOfInterest: 'Forfait Souhaité',
		preferredActivities: 'Activités Préférées',
		datesParameters: 'Dates & Paramètres',
		personalCredentials: 'Vos Coordonnées',
		stageLabel: 'Étape',
		ofLabel: 'sur',
		selectCoreExperienceStyle: 'Choisissez Votre Style de Séjour',
		howWishToSleepCommute: 'Comment Souhaitez-vous Voyager & Séjourner ?',
		howWishToSleepCommuteDesc:
			'Sélectionnez le niveau de confort et le mode de déplacement qui correspondent à vos envies.',
		exploreSpecializedActivities: 'Découvrez les Activités Exclusives',
		whatCapturesImagination: "Qu'est-ce qui Vous Fait Rêver ?",
		whatCapturesImaginationDesc:
			"Sélectionnez les expériences qui vous inspirent le plus. Notre équipe s'appuiera sur vos choix pour concevoir un voyage entièrement personnalisé.",
		timelineBudgetGroupParams: 'Dates, Budget & Composition du Groupe',
		expeditionDynamics: 'Détails du Séjour',
		expeditionDynamicsDesc: 'Indiquez la taille de votre groupe, votre style de transport et vos dates prévues.',
		dateFromWithAsterisk: 'Date de Début *',
		dateToWithAsterisk: 'Date de Fin *',
		howMuchToSpendWithAsterisk: 'Quel budget souhaitez-vous nous confier ? *',
		typeOfGroup: 'Type de Groupe',
		transportationChoice: 'Mode de Transport',
		numberOfGuests: 'Nombre de Voyageurs',
		childrenAgesLabel: 'Âges des Enfants (Optionnel)',
		childrenAgesPlaceholder: 'ex. 6, 11 (laisser vide si adultes uniquement)',
		childrenAgesHelp:
			'Certains lodges, safaris et activités prévoient un âge minimum. Renseigner l’âge des enfants nous aide à sélectionner les hébergements et activités parfaitement adaptés aux familles.',
		estimatedBlueprintBase: 'Estimation de Base',
		computedDuration: 'Durée Calculée :',
		nightsFor: 'nuits pour',
		paxLabel: 'pers.',
		includesLeviesNotice: '*Comprend les taxes de réserves, hors vols internationaux',
		fullNameWithAsterisk: 'Nom Complet *',
		emailAddressWithAsterisk: 'Adresse E-mail *',
		phoneNumberWithAsterisk: 'Numéro de Téléphone *',
		whereDoYouLive: 'Où Résidez-vous ? (Ville & Pays)',
		preferredDepartureAirport: 'Aéroport de Départ Souhaité (Ville)',
		wouldYouLikeFlightSuggestions: 'Souhaitez-vous des Propositions de Vols ?',
		yesSendFlightIdeas: 'Oui, faites-moi des suggestions',
		noAlreadySorted: "Non, j'ai déjà mes billets",
		anySpecialRequestsOrPreferences: 'Demandes Particulières ou Préférences ?',
		textareaSpecialRequestsPlaceholder:
			"Précisez vos régimes particuliers, souhaits photographiques, transferts spécifiques ou besoins d'accessibilité...",
		mandatoryCredentialsAlert:
			'Merci de renseigner les champs obligatoires (Nom, E-mail et Téléphone) afin que nous puissions vous attribuer un conseiller dédié.',
		telemetrySecure: 'Connexion Sécurisée',
		transmissionAlert: 'Alerte de Transmission',

		curatedMasterpieceTour: "Safari d'Exception /",
		durationLabel: 'Durée',
		paceCategoryLabel: 'Rythme',
		rateStartLabel: 'À partir de',
		journeyOverview: 'Aperçu du Voyage',
		wildLuxuryAccommodations: 'Hébergements de Prestige',
		dayByDayExperience: 'Programme Jour par Jour',
		selectDayBelow: 'L’itinéraire ci-dessous est un exemple de ce qui vous attend…',
		dayItinerary: 'Itinéraire du Jour {day}',
		dailyHighlightsEvents: 'Temps Forts & Activités',
		premiumInclusions: 'Prestations Haut de Gamme Incluses',
		requiredPreparations: 'Conseils & Préparatifs',
		checklistYellowFeverPrep: 'Certificat de vaccination fièvre jaune & traitement antipaludéen',
		checklistLuggageLimit: 'Sac de voyage souple obligatoire : maximum 15 kg',
		checklistVisaPrep: "Visas d'entrée à formaliser 30 jours avant le départ",
		totalPrivateRate: 'Tarif Privatif Total',
		inquireBookNow: 'Demander un Devis & Réserver',
		daysLabel: 'Jours',

		// Wizard Options
		styleLuxuryTitle: 'Séjour de Luxe',
		styleLuxuryDesc:
			"Séjournez dans des lodges de luxe et des réserves privées soigneusement sélectionnés, alliant un confort d'exception, des paysages magnifiques et des expériences de safari inoubliables.",
		styleLuxuryPrice: 'À partir de CHF 1 200/nuit',
		styleBudgetTitle: 'Séjour de Charme',
		styleBudgetDesc:
			"Profitez d'hébergements authentiques et confortables offrant un excellent rapport qualité-prix, au plus près de la faune et de la beauté naturelle de l'Afrique du Sud.",
		styleBudgetPrice: 'À partir de CHF 350/nuit',
		styleSelfDriveTitle: 'Circuit en Liberté (Self-Drive)',
		styleSelfDriveDesc:
			"Explorez l'Afrique du Sud à votre propre rythme grâce à un itinéraire personnalisé, des hébergements triés sur le volet et notre assistance tout au long de votre voyage.",
		styleSelfDrivePrice: 'À partir de CHF 480/nuit',
		styleBig5Title: 'Safari Spécial Big 5',
		styleBig5Desc:
			"Vivez des safaris guidés par des experts dans les plus belles réserves d'Afrique du Sud, avec l'opportunité d'observer les célèbres Big Five et bien plus encore.",
		styleBig5Price: 'À partir de CHF 850/nuit',
		stylePersonalisedTitle: 'Formule Sur Mesure',
		stylePersonalisedDesc:
			'Un voyage entièrement sur mesure conçu selon vos envies — combinant vos destinations préférées, vos hébergements, vos activités et votre rythme en un itinéraire fluide.',
		stylePersonalisedPrice: 'Tarification personnalisée',
		styleSustainableTitle: 'Immersion & Conservation Durable',
		styleSustainableDesc:
			'Découvrez le travail de conservation qui donne tout son sens à votre safari grâce à des expériences animalières éthiques, des initiatives écologiques et des rencontres avec ceux qui protègent la faune sauvage sud-africaine.',
		styleSustainablePrice: 'À partir de CHF 650/nuit',

		interestBig5Title: 'Observation des Big 5',
		interestBig5Label: 'Safaris Classiques',
		interestBig5Desc:
			"Vivez des rencontres inoubliables avec la faune lors de safaris guidés, avec l'opportunité d'observer les célèbres Big Five et l'incroyable diversité animale d'Afrique du Sud.",
		interestSportsTitle: 'Sports & Expériences Actives',
		interestSportsLabel: 'Aventure en Plein Air',
		interestSportsDesc:
			"Ajoutez de l'aventure à votre voyage avec des activités telles que la randonnée, le cyclisme, le golf, l'équitation et d'autres activités de plein air choisies selon vos goûts.",
		interestOceanTitle: 'Expériences Marines & Océan',
		interestOceanLabel: 'Côtier & Marin',
		interestOceanDesc:
			'Explorez le littoral sud-africain à travers des expériences incluant plongée, observation des baleines, pontes des tortues, surf, pêche et autres activités nautiques.',
		interestScenicTitle: 'Vols Panoramiques',
		interestScenicLabel: 'Survol en Basse Altitude',
		interestScenicDesc:
			"Découvrez l'Afrique du Sud sous un angle unique grâce à des vols panoramiques au-dessus de littoraux spectaculaires, de montagnes grandioses et de réserves sauvages.",
		interestConservationTitle: 'Conservation Durable',
		interestConservationLabel: 'Protection des Écosystèmes',
		interestConservationDesc:
			'Approfondissez votre compréhension de la protection de la faune grâce à des immersions éthiques de conservation, des ateliers éducatifs et des rencontres sur le terrain.',
		interestCulinaryTitle: 'Expérience Gastronomique',
		interestCulinaryLabel: "Vins Fins & Dîners d'Exception",
		interestCulinaryDesc:
			"Explorez l'Afrique du Sud à travers sa cuisine et ses vins, des saveurs authentiques du terroir aux dégustations dans les domaines viticoles et dîners inoubliables en brousse.",
		interestPhotographyTitle: 'Photographie Animalière',
		interestPhotographyLabel: 'Masterclass Photo',
		interestPhotographyDesc:
			'Véhicules adaptés avec supports pour téléobjectifs et conseils de cadrage par des spécialistes.',

		groupCouple: 'En Couple',
		groupFamily: 'En Famille',
		groupSolo: 'Voyageur Solo',
		groupFriends: 'Entre Amis',
		groupOther: 'Autre',

		transportOrganised: 'Transport Organisé & Guidé',
		transportSelfDrive: 'Conduite en Autonomie',
		transSelfDriving: 'Conduite en Autonomie',
		transOrganised: 'Transport Organisé & Guidé',

		wizardSuccessSecure: 'Demande Enregistrée avec Succès',
		wizardSuccessDesc:
			'Les options de réservation de concessions privées et de vols sont en cours de vérification auprès des registres locaux.',
		wizardSuccessPlanner: 'Conseiller Dédié :',
		wizardSuccessCredentials: 'Informations Transmises :',
		wizardSuccessDuration: 'Durée Prévue :',
		wizardSuccessNights: 'Nuits (Escorte privée garantie)',
		wizardSuccessGroup: 'Taille du Groupe :',
		wizardSuccessSecondary: 'Créer un Autre Itinéraire',
		wizardSuccessUnlock:
			"En envoyant votre demande, vous bénéficiez d'un échange direct avec votre créateur de voyage.",
		wizardPrev: 'Précédent',
		wizardNext: 'Étape Suivante',
		wizardSubmit: "Envoyer la Demande d'Itinéraire",
		wizardSubmitting: 'Transmission de la Demande...',
		wizardAssignedId: 'Code de Concession Assigné',
		recommendedLevel: 'Niveau Recommandé',

		// Testimonials / Guest Reviews / Guarantees
		simplifyingJourneyTitle: 'Simplifiez Votre Voyage Idéal',
		simplifyingJourneyDesc1:
			"Nos forfaits facilitent chaque étape de la réservation en s'adaptant à toutes les envies et à tous les budgets. Nous orchestrons chaque détail : hébergements, activités et transferts.",
		simplifyingJourneyDesc2: 'Nous veillons à ce que votre aventure soit une expérience merveilleuse que vous',
		guestChronicles: 'Avis des clients',
		guestChroniclesDesc: 'Des expériences authentiques : nos clients en parlent le mieux.',
		selectSafariStory: 'Choisir un Récit',
		verifiedAdventurer: 'Voyageur Vérifié • {location}',
		prevReview: 'Avis Précédent',
		nextReview: 'Avis Suivant',

		// Testimonial Specific Metadata (leaving quotes in english)
		tripBespokeSelfDrive: 'Expédition en Liberté Sur Mesure',
		tripCuratedWilderness: "Safari Sauvage d'Exception",
		tripUltraLuxuryAir: 'Vol Privé & Transferts Ultra-Luxe',
		highlightFlexibility: 'Liberté, Sérénité et Points d’Eau Sauvages',
		highlightMagical: 'Rencontres Animalières Magiques & Safaris Nocturnes',
		highlightIncomparable: 'Harmonie Incomparable entre Luxe et Nature',
		destTalamati: 'Parc National Kruger (Talamati Bushveld Camp)',
		destLionReserves: 'Parc National Kruger & Réserves des Félins',
		destSandibe: "Delta de l'Okavango (Réserve Privée de Sandibe)",

		// Travel Styles UI
		readNarrative: 'Lire le Détail',
		hideNarrative: 'Masquer le Détail',
		discoverOurPackages: 'Découvrez Nos Formules',
		pristineHighlights: 'Prestations Incluses',
		startFrom: 'À partir de',
		ourServicesTab: 'Nos Services & Formules de Voyage',
		seamlessEnrichingTitle: 'Des Safaris Fluides et Enrichissants',
		seamlessEnrichingSubtitle1:
			"Chez Elephant Expeditions, notre mission est de partager notre passion pour les animaux africains et le voyage en créant une expérience enrichissante et sereine que vous n'oublierez jamais.",
		seamlessEnrichingSubtitle2:
			"Conçues pour les couples, familles et groupes d'Europe et d'ailleurs, nos formules s'adressent à tous ceux qui souhaitent découvrir la faune majestueuse et les paysages d'Afrique du Sud.",

		// Travel Styles Content French
		style_luxury_title: 'Séjours de Prestige',
		style_luxury_subtitle: 'Hébergements haut de gamme dans des lodges exclusifs et réserves privées.',
		style_luxury_desc:
			'Plongez dans un véritable havre de paix. Séjournez dans des lodges raffinés et réserves privées alliant les standards de confort les plus élevés à une immersion totale au cœur de la nature.',
		style_luxury_h1: 'Hébergements de grand standing dans des lodges exclusifs et réserves privées.',
		style_luxury_h2: 'Safaris guidés pour observer la faune dans des concessions privatives.',
		style_luxury_h3: "Services d'exception incluant soins spa et itinéraires personnalisés.",
		style_luxury_eco: 'Alliance Éco-Luxe Gold',

		style_budget_title: 'Séjours de Charme',
		style_budget_subtitle: "Des formules accessibles sans aucun compromis sur la qualité de l'expérience.",
		style_budget_desc:
			"Vivez la magie de la brousse africaine dans une atmosphère chaleureuse. Séjournez dans des guesthouses et lodges de charme privilégiant le confort, l'accueil et l'authenticité.",
		style_budget_h1: "Des formules avantageuses préservant toute l'intensité de l'aventure.",
		style_budget_h2: 'Hébergements de charme offrant un excellent niveau de confort et de convivialité.',
		style_budget_h3: 'Safaris guidés avec options en pension complète ou formules flexibles.',
		style_budget_eco: 'Norme Écoresponsable Green Standard',

		style_selfdrive_title: 'Circuits en Liberté (Self-Drive)',
		style_selfdrive_subtitle: 'Pour les voyageurs désireux de parcourir les grands espaces au volant de leur véhicule.',
		style_selfdrive_desc:
			"La liberté absolue de l'aventure à votre rythme. Nous vous fournissons des itinéraires rigoureusement préparés, des étapes recommandées et la réservation de vos hébergements pour un voyage serein.",
		style_selfdrive_h1: "Itinéraires optimisés, étapes clés et hébergements réservés à l'avance.",
		style_selfdrive_h2: 'Suggestions pour la location de véhicules.',
		style_selfdrive_h3: 'Conseils avisés pour explorer chaque région en toute sérénité à votre propre rythme.',
		style_selfdrive_eco: 'Compensation Carbone des Trajets Incluse',

		style_big5_title: 'Safaris Découverte des Big 5',
		style_big5_subtitle: "Des itinéraires dédiés à la rencontre des cinq animaux emblématiques d'Afrique.",
		style_big5_desc:
			"Des safaris spécialement conçus pour observer les célèbres Big 5 : Lion, Léopard, Éléphant, Rhinocéros et Buffle. Accompagnés par des pisteurs d'exception dans les plus beaux parcs d'Afrique du Sud.",
		style_big5_h1: "Safaris ciblés sur l'observation des Big 5 (Lion, Léopard, Éléphant, Rhinocéros et Buffle).",
		style_big5_h2: 'Exploration de réserves exceptionnelles et parcs nationaux renommés.',
		style_big5_h3: 'Opportunités idéales pour le pistage, la photographie et la découverte de la brousse.',
		style_big5_eco: 'Soutien aux Fonds des Rangers de Terrain',

		style_personalized_title: 'Forfaits Sur Mesure',
		style_personalized_subtitle: "Bien plus qu'un simple safari : une création pensée uniquement pour vous.",
		style_personalized_desc:
			"Des voyages sur mesure créés pour donner vie à votre vision d'une aventure africaine idéale. Découvrez toute la richesse de l'Afrique : faune sauvage, panoramas grandioses, haute gastronomie et rencontres culturelles.",
		style_personalized_h1:
			'Adapté à vos préférences : faune sauvage, paysages pittoresques, vie balnéaire, étapes culinaires ou culturelles.',
		style_personalized_h2:
			'Activités exclusives : survols scéniques, croisières au coucher du soleil, observation des baleines.',
		style_personalized_h3: "Possibilité d'être accompagné par un guide photographe professionnel.",
		style_personalized_eco: 'Retombées Directes pour les Communautés Locales',

		style_sustainable_title: 'Immersion & Conservation Durable',
		style_sustainable_subtitle:
			'Expériences de protection faunique. Participez activement à la sauvegarde de la biodiversité.',
		style_sustainable_desc:
			'Impliquez-vous au cœur des initiatives de conservation. Participez à des projets concrets et rigoureux de protection animale qui vous offriront une compréhension approfondie des enjeux écologiques sud-africains.',
		style_sustainable_h1: 'Expériences immersives pour comprendre les actions de protection de la faune africaine.',
		style_sustainable_h2:
			'Participation possible au suivi des rhinocéros, observation des pangolins ou sessions de monitoring.',
		style_sustainable_h3: 'Interactions éthiques et respectueuses garantissant le bien-être animal.',
		style_sustainable_eco: 'Certification Éthique 100% Validée',
	},
	de: {
		// Header
		discover: 'Entdecken',
		curatedSafaris: 'Kuratierte Safaris',
		bespokePlanner: 'Individueller Planer',
		designBespoke: 'Bespoke planen',
		inquiries: 'Anfragen',
		savedSafaris: 'Gespeicherte Safaris',
		allTerritories: 'Alle Gebiete',
		allCollections: 'Alle Kollektionen',
		selectDest: 'Reiseziel wählen',
		selectExp: 'Erlebnis wählen',
		ourStoryTab: 'Unsere Geschichte',
		contactUsTab: 'Kontakt',
		savedTab: 'Gespeichert',

		// Hero Section
		wildMeetsExquisite: 'Ein wildes Erlebnis, das Sie nie vergessen werden',
		discoverSouthAfrica: 'Entdecken Sie Südafrika',
		heroSubtitle:
			'Bei Elephant Expeditions ist es unser Ziel, unsere Leidenschaft für afrikanische Tiere und das Reisen mit Ihnen zu teilen. Wir schaffen ein nahtloses, bereicherndes Reiseerlebnis, das Sie NIE VERGESSEN WERDEN! Entdecken Sie Südafrikas feinste Luxus-Lodges, charmante Budget-Unterkünfte, Selbstfahrer-Touren und spektakuläre Big-5-Safaris.',
		neverForget: 'NIE VERGESSEN!',
		curatedTravelStyles: 'Kuratierte Safaritouren',
		ethcialSafaris: 'Zu 100 % ethische Safaris',
		conservationFocused: 'Zu 100 % auf Naturschutz ausgerichtet',
		authenticExperiences: 'Authentische Erlebnisse',
		territoryPatrolStatus: 'Aktiver Revier-Patrouillenstatus',
		secureSabiSands: '● GESICHERT - SABI-SAND-RESERVATE',
		krugerActivityEstimate: 'Kruger-Wildtieraktivitätsschätzung',
		highDensityHerdTracking: 'Hohe Herdendichte-Ortung',
		satelliteRelayOnline: 'Satellitenrelais online',
		capeTownHqSync: 'Kapstadt-Zentrale Sync Link OK',
		heroBadge: 'Biologischer Naturschutz',

		// Grid and Cards
		difficultyRelaxed: 'Entspannt',
		difficultyModerate: 'Moderat',
		difficultyActive: 'Aktiv',
		bespokeTitle: 'Maßgeschneiderte / Individuelle Reise',
		bespokeLocation: 'Individuelle Afrikanische Reiseziele',
		bespokeDesc: 'Gestalten Sie eine vollkommen maßgeschneiderte Südafrika-Wildnisreise gemeinsam mit unserem Team.',
		days: 'Tage',
		fromPrice: 'Ab',
		perPerson: 'pro Person',
		reviews: 'Bewertungen',
		featured: 'Empfohlen',
		saveToInquiry: 'Merken',
		saved: 'Gespeichert',
		viewItinerary: 'Details & Reiseverlauf',
		bookExpedition: 'Expedition anfragen',
		noResults: 'Keine Treffer gefunden. Wählen Sie breitere Wildnis-Koordinaten.',

		// Our Story Section
		aboutUsHeader: 'Ein Erbe im Staub geschrieben',
		aboutUsTitlePart1: 'Unsere Geschichte, ',
		aboutUsTitlePart2: 'Unsere Leidenschaft.',
		aboutParagraph1:
			'Elephant Expeditions hat seinen Sitz in der Schweiz und entstand aus der gemeinsamen Leidenschaft von Kyle und Rossella Blewitt für Afrika, seine atemberaubende Tierwelt und seine natürliche Schönheit. Gemeinsam haben Kyle und Rossella Elephant Expeditions auf den Säulen des Naturschutzes, des ethischen Tourismus und echter Gästeerlebnisse aufgebaut. Sie glauben, dass jede Safari nicht nur unvergesslich sein sollte, sondern auch aktiv zum Schutz des natürlichen Erbes Afrikas beitragen muss. Durch die Partnerschaft mit lokalen Gemeinschaften und Naturschutzprojekten stellt Elephant Expeditions sicher, dass jede Reise nachhaltige Praktiken unterstützt und ein tieferes Verständnis für die einzigartigen Ökosysteme des Kontinents fördert.',
		aboutParagraph2:
			'Bei Elephant Expeditions sind Gäste eingeladen, Afrikas atemberaubende Landschaften zu erkunden und seiner unglaublichen Tierwelt durch durchdachte Reiserouten zu begegnen, die die Umwelt respektieren und ehren. Ob Sie eine Luxus-Lodge-Reise, ein Selbstfahrer-Abenteuer oder eine Fotosafari unternehmen – Kyle und Rossellas Engagement für Authentizität und Naturschutz garantiert ein bedeutungsvolles und unvergessliches Erlebnis, das Sie nie vergessen werden.',
		foundingYearLabel: 'Gründungsjahr',
		ethicalLabel: 'Ethisch',
		personalLabel: 'PERSÖNLICH',
		personalLabelDesc: 'von Anfang bis Ende',
		foundersTitle: 'Lernen Sie die Gründer kennen',
		foundersTitleDesc:
			'Elephant Expeditions entstand an der Frontlinie des afrikanischen Busches und auf der Basis höchster europäischer Luxusstandards. Aus ihrer gemeinsamen Liebe zur unberührten Wildnis heraus steuern Kyle und Rossella die Planung jeder maßgeschneiderten Safari direkt aus der Schweiz.',
		founderKyleTitle: 'Mitgründer / Pilot & Fotograf',
		founderKyleBio:
			'Kyle Blewitts Lebensweg liest sich wie ein Abenteuerroman. Schon seit seinem 15. Lebensjahr ist Kyle als Pilot tätig und hat unzählige Stunden über einigen der atemberaubendsten Landschaften der Welt verbracht – von den weiten Savannen Afrikas über das zerklüftete Gelände Indiens bis hin zu den kristallklaren Gewässern der Seychellen. Sein fliegerisches Spektrum reichte dabei von medizinischen Evakuierungen und Frachtflügen in abgelegenen Regionen bis hin zur Steuerung von Privatjets über Europa, Nordafrika und Asien. Doch ganz gleich, wohin ihn seine Wege führen: Sein Herz zieht es immer wieder zurück in den afrikanischen Busch.',
		founderKyleBio2:
			'Aufgewachsen in Südafrika, war Kyle von klein auf in der Wildnis unterwegs, wo er eine tiefe Wertschätzung für Afrikas Tiere und Ökosysteme entwickelte. Seine Kindheit verbrachte er mit Speerfischen, Angeln und der Entdeckung der reichen Feinheiten von Afrikas Fauna und Flora. Im Laufe der Zeit entwickelte er ein tiefes Verständnis für das empfindliche Gleichgewicht zwischen menschlicher Aktivität und Naturschutz, das zu einem leitenden Prinzip seiner Arbeit geworden ist.',
		founderKyleBio3:
			'Heute lebt Kyle in der Schweiz, spürt aber den Drang, seine Liebe zu den afrikanischen Landschaften, ihrer ungezähmten Schönheit und ihrer vielfältigen Tierwelt mit anderen zu teilen. Die Gründung von Elephant Expeditions war für ihn eine Möglichkeit, nach Afrika „nach Hause“ zu kommen und gleichzeitig den Reisenden die Gelegenheit zu geben, die Magie zu erleben, die er schon immer gekannt hat.',
		founderRossellaTitle: 'Mitgründerin / Pädagogin & Naturschützerin',
		founderRossellaBio:
			'Rossella Blewitts Lebensweg ist geprägt von Entdeckungsdrang, Bildung und einer tiefen Leidenschaft für Tiere. Sie ist in der Schweiz geboren und aufgewachsen und arbeitet als Englischlehrerin im Kanton Tessin. Ihr akademischer Werdegang führte sie nach Großbritannien, Island und Italien; zudem erweiterten ausgedehnte Reisen rund um den Globus ihren Horizont.',
		founderRossellaBio2:
			'Ihr Leben nahm eine unerwartete und wunderbare Wendung, als sie sich für ein Freiwilligenprogramm bei Wildlife ACT anmeldete, in dessen Rahmen sie in Südafrika bei der Erforschung und Überwachung bedrohter Tierarten mitwirkte. Dort lernte sie Kyle kennen – ihren heutigen Ehemann und Mitbegründer von Elephant Expeditions – und verliebte sich nicht nur in ihn, sondern auch in den afrikanischen Kontinent.',
		founderRossellaBio3:
			'Seitdem hat sich Rossellas Verbindung zu Afrika noch weiter vertieft. Sie machte die einzigartige Erfahrung, Schuppentiere in Reservaten aufzuspüren, in denen die „Big Five“ beheimatet sind, und bereist weiterhin Südafrika, wobei sie durch Kurse ihr Wissen erweitert. Ihre Leidenschaft für die afrikanische Tierwelt und deren Schutz treibt sie dazu an, sich fortlaufend über die Flora und Fauna des Kontinents zu informieren.',
		founderRossellaBio4:
			'Rossellas Mischung aus akademischem Wissen und praktischer Erfahrung in der Wildnis ermöglicht es ihr, eine Verbindung zu den Reisenden herzustellen und ihnen eine authentische Perspektive auf Afrikas Tierwelt und Kultur zu bieten. Gemeinsam mit Kyle bringt sie Leidenschaft, Wissen und Engagement in Elephant Expeditions ein und schafft unvergessliche Safari-Erlebnisse.',
		coreCommitmentsTitle: 'Unser Engagement für ethische Safaris',
		coreCommitmentsSubtitle:
			'Wir bei Elephant Expeditions glauben, dass eine unvergessliche Safari einen positiven Einfluss auf die Tierwelt, die unberührten Lebensräume und die Gemeinschaften haben sollte, die sie ermöglichen.',
		pillarAntiPoachingTitle: 'Unterstützung des Naturschutzes',
		pillarAntiPoachingDesc:
			'Wir wählen Lodges, Reservate und Erlebnisse sorgfältig aus, die aktiv zum Schutz der Tierwelt und zum Erhalt natürlicher Lebensräume beitragen. Mit ihrer Reise unterstützen unsere Gäste den Naturschutz durch verantwortungsvollen Tourismus.',
		pillarCommunityTitle: 'Verantwortungsvolles & ethisches Reisen',
		pillarCommunityDesc:
			'Das Wohl der Tiere und eine respektvolle Tierbeobachtung stehen im Mittelpunkt jeder unserer Safaris. Wir bevorzugen ethische Partner und Erlebnisse, die den Tieren ihren natürlichen Freiraum lassen.',
		pillarSovereignTrustTitle: 'Gäste mit dem Naturschutz verbinden',
		pillarSovereignTrustDesc:
			'Wir glauben, dass eine Safari bedeutungsvoller ist, wenn man versteht, was man sieht. Wir vermitteln unseren Gästen Wissen über Wildtiere, Ökosysteme und Naturschutz und schaffen so eine tiefere Verbindung zu Südafrika und seinem Naturerbe.',
		impactTitle: 'Echtzeit-Naturschutz-Rechner',
		impactSubtitle:
			'Geben Sie Ihr geplantes Expeditions-Budget ein, um den direkt vor Ort finanzierten Naturschutzbeitrag zu ermitteln.',
		investmentLabel: 'Geplantes Expeditions-Budget (CHF)',
		calculatedImpact: 'Berechneter Beitrag für die Wildnis',
		antiPoachingPatrols: 'Wilderer-Schutzpatrouillen',
		antiPoachingDesc: 'Vollständig finanzierte Ranger-Stunden ausgerüstet mit Funk- & Ortungstechnik.',
		co2Reduction: 'CO2-Schutz im Reservat',
		co2Desc: 'Tonnen CO2-Speicherung durch den aktiven Schutz der lokalen Savanne.',
		protectedAcres: 'Geschützte Wildnisfläche',
		protectedDesc: 'Hektar unberührte Natur, die rund um die Uhr von permanenten Patrouillen bewacht werden.',
		schoolMaterialWeeks: 'Schulmaterial (Wochen)',
		schoolDesc: 'Wochen voller Schulmaterial, das für die Kinder lokaler Gemeinden finanziert wird.',

		// Itinerary Drawer
		overviewTab: 'Übersicht',
		detailedItineraryTab: 'Reiseverlauf',
		accommodationsInclusionsTab: 'Unterkünfte & Inklusivleistungen',
		closeButton: 'Schließen',
		highlightsHeader: 'Highlights',
		accommodationsHeader: 'Unterkünfte',
		inclusionsHeader: 'Inbegriffene Leistungen',
		dayLabel: 'Tag',

		// Booking & Quote Wizard
		bespokeTripPlanner: 'Bespoke Expeditions-Planer',
		designBespokeTitle: 'Ihre persönliche Reise',
		wizardStep1Title: 'Wählen Sie Ihr Reiseziel',
		wizardStep1Desc: 'Sich entscheiden Sie für eines unserer unberührten Naturschutzgebiete.',
		wizardStep2Title: 'Stil der Unterkunft',
		wizardStep2Desc: 'Wählen Sie Ihren bevorzugten Camp-Stil und das gewünschte Komfortniveau.',
		wizardStep3Title: 'Naturschutz-Fokus',
		wizardStep3Desc: 'Destinieren Sie einen Prozentsatz des Buchungswertes für direkten Schutz vor Ort.',
		wizardStep4Title: 'Expeditions-Details',
		wizardStep4Desc: 'Logistik, Inlandsflüge und Verpflegungswünsche in der Wildnis.',
		wizardStep5Title: 'Kontaktdaten',
		wizardStep5Desc:
			'Unser Team nutzt Ihre Wünsche, um eine maßgeschneiderte Südafrika-Reise perfekt für Sie zu gestalten.',
		nextStep: 'Weiter',
		prevStep: 'Zurück',
		submitting: 'Wird an die Ranger übermittelt...',
		submitInquiry: 'Maßgeschneiderte Anfrage senden',
		successTitle: 'Anfrage erfolgreich übermittelt',
		successDesc:
			'Ihre Anfrage wurde an unsere Partner in Sabi Sands und Kapstadt übermittelt. Ein persönlicher Reiseplaner wird sich innerhalb der nächsten 24 Stunden mit einem maßgeschneiderten Entwurf bei Ihnen melden.',

		// Extra UI Keys
		reservationDesk: 'Expeditions-Reservierungsstelle',
		desiredDepartureDate: 'Wunsch-Abreisedatum',
		travelerCount: 'Anzahl der Reisenden (Gäste)',
		guest: 'Gast',
		guests: 'Gäste',
		aviationUpgrade: 'Aviation Charter Transfer Upgrade',
		standardBushRun: 'Standard-Fahrt in der Wildnis',
		includedInBase: 'Im Basispreis enthalten',
		privateCessnaCaravan: 'Private Cessna Caravan',
		cessnaCostDesc: '+CHF 1.800 Gruppenaufpreis',
		charteredHelicopter: 'Gecharterter Hubschrauber',
		helicopterCostDesc: '+CHF 3.400 flache Gruppenpauschale',
		culinaryPackageLevel: 'Niveau des Kulinarik- & Verpflegungspakets',
		savannahClassic: 'Savannen-Klassiker',
		gourmetDiningInc: 'Gourmet-Verpflegung (Inkl)',
		bushVeganOrganic: 'Wildnis Vegan & Biologisch',
		veganCostDesc: '+CHF 120 / Tag / Person',
		gourmetCellars: 'Gourmet-Weinkeller',
		cellarCostDesc: '+CHF 180 / Tag / Person',
		coordinationDetailContact: 'Koordinations-Kontakt',
		yourFullName: 'Ihr vollständiger Name',
		yourEmail: 'Ihre E-Mail-Adresse',
		customNotesOrReminders: 'Besondere Anmerkungen, Allergien oder Diäthinweise',
		submitPrivateInquiry: 'Private Anfrage absenden',
		expeditionPendingConsultation: 'Expedition wartet auf Beratung',
		trackingDetailsLogged: 'Ihre Ortungsdaten wurden auf unserem Feldfunknetzwerk registriert.',
		inquiryReferenceKey: 'Anfrage-Referenznummer',
		estTotalSum: 'Geschätzter Gesamtbetrag',
		preparatoryPdfRouted:
			'Ein detailliertes Vorbereitungs-PDF mit erforderlichen Impfungen, Flugverbindungen und Packempfehlungen wurde gesendet an',
		safariPrepChecklist: 'Ihre Safari-Vorbereitungs-Checkliste',
		checklistYellowFever: 'Sichern Sie sich eine offizielle digitale Kopie Ihres Gelbfieber-Zertifikats',
		checklistDuffel: 'Kaufen Sie weiches Reisetaschen-Gepäck (harte Koffer sind in den Cessna-Kabinen verboten)',
		checklistClothing: 'Bestellen Sie neutrale Kleidung in den Farben Khaki, Grün oder Sand für die Trekking-Touren',
		returnToExploration: 'Zurück zur Übersicht',
		daysPrivateGuided: 'Tage Privat geführtes Erlebnis',
		financialQuotation: 'Finanzielles Angebot',
		baseRate: 'Grundpreis',
		cessnaCommuterCharter: 'Cessna Commuter Charter',
		charteredHeliTransfer: 'Gecharterter Heli-Transfer',
		vegetarianOrganicTier: 'Vegetarisch-Biologische Stufe',
		gameCellarWinePackage: 'Wild- & Weinkeller-Paket',
		financialQuotationNotice:
			'• Inklusive Naturschutz-Beiträgen, Premium-Doppelzelt-Unterkunft und privaten 4x4 Jeep-Touren vor Ort.',
		estimatedPrivateTotal: 'Geschätzter privater Gesamtpreis',
		letsDesignExperience: 'Gestalten wir Ihr Erlebnis',
		contactIntroText:
			'Verbinden Sie sich direkt mit uns. Egal, ob Sie Fragen zu den lokalen Routen haben, einen privaten Preis benötigen oder direkt mit der Planung Ihrer maßgeschneiderten Safari beginnen möchten – unser Expertenteam ist für Sie da.',
		conciergeDesksText:
			'Wir arbeiten auf Basis von persönlichem Vertraue und tiefem Fachwissen vor Ort. Die Planung der Luxusrouten wird direkt von unserem europäischen Hauptsitz und der Basis in Südafrika geleitet.',
		ourLocations: 'Unsere Standorte',
		switzerlandAndSouthAfrica: 'Schweiz & Südafrika',
		directLine: 'Direkter Draht',
		instantWhatsAppChat: 'Sofortiger WhatsApp-Chat',
		connectWhatsAppText: 'Schreiben Sie direkt an Kyle und Rossella Blewitt.',
		openWhatsAppButton: 'WhatsApp öffnen',
		officialCorrespondence: 'Offizielle Korrespondenz',
		followOurJourneys: 'Folgen Sie unseren Reisen',
		guaranteedResponseText: 'Garantierte Antwort innerhalb eines Werktages',
		inquiryForwarded: 'Anfrage weitergeleitet',
		inquiryForwardedText:
			'Vielen Dank für die Übermittlung Ihrer Wünsche. Eine E-Mail wurde versendet und Kyle & Rossella wurden benachrichtigt. Sie erhalten in Kürze einen maßgeschneiderten Entwurf in Ihrem Posteingang.',
		sendAnotherMessage: 'Eine weitere Nachricht senden',
		conciergeMessageStream: 'Concierge-Nachrichtenstrom',
		conciergeMessageStreamText: 'Füllen Sie die Felder aus, um eine direkte verschlüsselte Anfrage an uns zu senden.',
		fullName: 'Vollständiger Name',
		emailAddress: 'E-Mail-Adresse',
		contactPhoneLine: 'Telefonnummer',
		optionalLabel: '(Optional)',
		detailedInquiryMessage: 'Detaillierte Nachricht',
		transmittingCorrespondence: 'Nachricht wird gesendet...',
		transmitMessage: 'Nachricht senden',

		leadSafariPlanner: 'Haupt-Safariplanerin',
		sovereignEncryptionSecure: 'Sichere Verschlüsselung aktiv',
		welcomeMessage:
			'Jambo! Wie dürfen wir Ihre Traumreise in die afrikanische Wildnis planen? Nennen Sie mir einfach Ihre Wunschdaten oder die Gruppengröße.',
		typicallyReplies: 'Concierge-Leitung • Antwortet meistens innerhalb von 5m',
		typeBespokeQuestDetail: 'Schreiben Sie Ihre Reisewünsche auf...',
		directWhatsAppInquire: 'Direkte WhatsApp-Anfrage',
		safariPlannerOnline: 'Safari-Planer online',
		promptText: 'Chatten Sie live via WhatsApp mit unserem Team!',

		homeTab: 'Home',
		safarisTab: 'Safaris & Pakete',
		storyTab: 'Unsere Geschichte',
		contactTab: 'Kontakt',
		requestAQuote: 'Angebot anfordern',
		est2025Text: 'Seit 2025 • Luxus & Wildnis',
		footerAboutText:
			'Seit unserer Gründung ist es unser Ziel, die Leidenschaft für afrikanische Wildtiere und das Reisen mit Ihnen zu teilen und ein unvergessliches, bereicherndes Erlebnis zu schaffen. Ein direkter Prozentsatz der Einnahmen finanziert die Ranger vor Ort zum Schutz vor Wilderei.',
		followOurJourneysLabel: 'Folgen Sie unseren Reisen:',
		fullyCertifiedASTA: 'Zertifiziert durch die African Sustainable Tourism Alliance.',
		termsAndConditions: 'Allgemeine Geschäftsbedingungen',
		privacyPolicy: 'Datenschutzerklärung',
		indemnity: 'Haftungsausschluss',
		wildlifeBylaws: 'Allgemeine Geschäftsbedingungen',
		cessnaLuggageParameters: 'Datenschutzerklärung',
		privacyCharter: 'Haftungsausschluss',

		filterCuratedRoutesDirectly: 'Safari-Routen filtern',
		customQuickSearch: 'Schnellsuche',
		featuredPrivateExpeditions: 'Bevorstehende Expeditionen',
		africanMasterpieces: 'Afrikanische Meisterwerke',
		exploreCuratedCollection: 'Entdecken Sie die Kollektion',
		craftBespokeMasterpiece: 'Nichts Passendes? Planen Sie eine maßgeschneiderte Traumreise.',
		tailoredWilderness: 'Ihr persönliches Abenteuer',
		craftBespokeSubtitle:
			'Mit unserem interaktiven Planungstool können Sie gezielt Regionen in Südafrika auswählen, das Luxusniveau anpassen, bevorzugte Aktivitäten festlegen und die voraussichtlichen Kosten direkt berechnen.',
		openBespokePlanner: 'Bespoke Planer öffnen',
		safeguardingIvoryPathfinders: 'Schutz der südafrikanischen Tierwelt',
		ourHeritage: 'Unser Erbe',
		conservationPartnerships: 'Naturschutz-Programme',
		safarisThatProtect: 'Erlebnisse, die schützen und bewahren',
		safarisThatProtectDesc:
			'Informieren Sie sich bitte über diese Vereinigungen, die sich den Schutz und die Überwachung gefährdeter Arten zum Ziel gesetzt haben.',
		over240kContributed: 'Über CHF 240k Gespendet',
		empoweringCommunityRangers: 'Unterstützung für Ranger und Tierärzte vor Ort',
		lowImpactFootprints: 'Kleiner ökologischer Fußabdruck',
		strictDoubleOccupancy: 'Strenge Grenzen von Gästen pro Hektar',
		curatedSafariExpeditionsTitle: 'Kuratierte Safari-Routen',
		curatedSafariExpeditionsDesc: 'Private Reisen in die besten Schutzgebiete mit exklusiven Cessna-Flügen.',
		territoryLabel: 'Gebiet: ',
		collectionLabel: 'Sammlung: ',
		clearFilters: 'Filter löschen',
		noCustomMatches: 'Keine passenden Routen gefunden',
		noCustomMatchesDesc:
			'Leider haben wir keine passenden Routen für Ihre Filter gefunden. Passen Sie die Suche an oder nutzen Sie unseren Bespoke Planer unten.',
		seeAllSafaris: 'Alle Safaris anzeigen',
		dreamingAviationRouting: 'Träumen Sie von Ihrer eigenen Flugroute?',
		dreamingAviationRoutingDesc:
			'Kombinieren Sie Serengeti, Gorilla-Wälder in Ruanda und Botswana im Bespoke Planer für ein direktes Angebot.',
		goToBespokePlanner: 'Zum Bespoke Planer',
		designYourWildernessJourney: 'Gestalten Sie Ihre Wildnis-Reise',
		designYourWildernessJourneyDesc:
			'Planen Sie Ihre private Safari, organisieren Sie Transfers und erhalten Sie schnelle Kostenvoranschläge für Ihre maßgeschneiderte Afrika-Reise.',
		curatedCustomWishlists: 'Ihr persönliches Wunsch-Abenteuer',
		mySavedSafaris: 'Meine gespeicherten Safaris',
		mySavedSafarisDesc: 'Sehen Sie sich Ihre Lieblings-Safaris an und buchen Sie eine gemeinsame Beratung mit uns.',
		noSafarisCached: 'Keine Safaris gespeichert',
		noSafarisCachedDesc: 'Klicken Sie auf das Herz-Symbol bei den Safaris, um die Touren hier zu speichern.',
		goToCuratedSafaris: 'Zu den Safaris',
		myActiveInquiries: 'Meine bestehenden Anfragen',
		loggedLabel: 'Registriert',
		bespokeDayArchitectJourney: 'Maßgeschneiderte {duration}-Tage-Traumreise',
		guestsLabel: 'Gäste:',
		dateLabel: 'Datum:',
		commuteColon: 'Flug/Fahrt:',
		culinaryColon: 'Verpflegung:',
		destinationsColon: 'Zielgebiete:',
		tierLevelColon: 'Luxus-Klasse:',
		reviewActiveStatus: 'Status überprüfen',
		closeInquiryPanel: 'Anfrage-Fenster schließen',

		packageOfInterest: 'Gewünschtes Paket',
		preferredActivities: 'Gewünschte Aktivitäten',
		datesParameters: 'Wunsch-Daten & Details',
		personalCredentials: 'Persönliche Daten',
		stageLabel: 'Schritt',
		ofLabel: 'von',
		selectCoreExperienceStyle: 'Wählen Sie den Stil des Abenteuers',
		howWishToSleepCommute: 'Wie möchten Sie schlafen & reisen?',
		howWishToSleepCommuteDesc:
			'Wählen Sie die Art der Unterkunft und die Transportmittel, die am besten zu Ihren Wünschen passen.',
		exploreSpecializedActivities: 'Spezial-Aktivitäten vor Ort',
		whatCapturesImagination: 'Was fasziniert Sie am meisten?',
		whatCapturesImaginationDesc:
			'Wählen Sie die Erlebnisse, die Sie am meisten interessieren. Unser Team nutzt Ihre Auswahl, um eine perfekt auf Sie zugeschnittene Reise zu gestalten.',
		timelineBudgetGroupParams: 'Termin, Budget & Gruppen-Details',
		expeditionDynamics: 'Reise-Details',
		expeditionDynamicsDesc:
			'Sagen Sie uns, wie viele Personen in der Gruppe sind, welches Transportmittel Sie bevorzugen und Ihre Wunschdaten.',
		dateFromWithAsterisk: 'Datum von *',
		dateToWithAsterisk: 'Datum bis *',
		howMuchToSpendWithAsterisk: 'Mit welchem Budget möchten Sie, dass wir planen? *',
		typeOfGroup: 'Art der Gruppe',
		transportationChoice: 'Transportmittel',
		numberOfGuests: 'Anzahl Gäste',
		childrenAgesLabel: 'Alter der Kinder (Optional)',
		childrenAgesPlaceholder: 'z. B. 6, 11 (leer lassen, wenn nur Erwachsene)',
		childrenAgesHelp:
			'Manche Lodges, Pirschfahrten und Aktivitäten haben Altersrichtlinien. Die Angabe des Kinderalters ermöglicht uns die Auswahl optimaler, familienfreundlicher Unterkünfte und Erlebnisse.',
		estimatedBlueprintBase: 'Geschätzter Basispreis',
		computedDuration: 'Geschätzte Reisedauer:',
		nightsFor: 'Nächte für',
		paxLabel: 'Reisende',
		includesLeviesNotice: '*Inklusive Park-Gebühren, ohne Langstreckenflüge',
		fullNameWithAsterisk: 'Vollständiger Name *',
		emailAddressWithAsterisk: 'E-Mail-Adresse *',
		phoneNumberWithAsterisk: 'Telefonnummer *',
		whereDoYouLive: 'Wo wohnen Sie? (Stadt & Land)',
		preferredDepartureAirport: 'Bevorzugter Abflughafen',
		wouldYouLikeFlightSuggestions: 'Möchten Sie Flugvorschläge von uns?',
		yesSendFlightIdeas: 'Ja, bitte Flüge vorschlagen',
		noAlreadySorted: 'Nein, ich habe mich bereits selbst darum gekümmert',
		anySpecialRequestsOrPreferences: 'Sonderwünsche oder Bemerkungen?',
		textareaSpecialRequestsPlaceholder:
			'Beschreiben Sie Spezialdiäten, fotografische Ausrüstung, Gorilla-Tracking-Wünsche, Barrierefreiheit...',
		mandatoryCredentialsAlert:
			'Bitte füllen Sie die Pflichtfelder (Name, E-Mail und Telefon) aus, damit wir Ihnen einen Berater zuteilen können.',
		telemetrySecure: 'Daten übermittelt',
		transmissionAlert: 'Übermittlungs-Warnung',

		curatedMasterpieceTour: 'Kuratierte Meister-Tour /',
		durationLabel: 'Reisedauer',
		paceCategoryLabel: 'Tempo-Klasse',
		rateStartLabel: 'Preis ab',
		journeyOverview: 'Übersicht der Reise',
		wildLuxuryAccommodations: 'Luxus-Unterkünfte in der Wildnis',
		dayByDayExperience: 'Ablauf Tag für Tag',
		selectDayBelow: 'Der folgende Reiseverlauf ist ein Beispiel dafür, was Sie erwartet…',
		dayItinerary: 'Ablauf Tag {day}',
		dailyHighlightsEvents: 'Highlights & Erlebnisse des Tages',
		premiumInclusions: 'Inbegriffene Premium-Leistungen',
		requiredPreparations: 'Notwendige Vorbereitungen',
		checklistYellowFeverPrep: 'Gültiger Gelbfieber-Impfausweis & Malaria-Prophylaxe',
		checklistLuggageLimit: 'Weiche Reisetasche ohne hartes Gestell erlaubt: max. 15kg',
		checklistVisaPrep: 'Visa müssen spätestens 30 Tage vor der Abreise vorliegen',
		totalPrivateRate: 'Gesamtpreis für die Gruppe',
		inquireBookNow: 'Anfragen & buchen',
		daysLabel: 'Tage',

		// Wizard Options
		styleLuxuryTitle: 'Luxus-Unterkunft',
		styleLuxuryDesc:
			'Übernachten Sie in sorgfältig ausgewählten Luxus-Lodges und privaten Reservaten, die erstklassigen Komfort, traumhafte Lagen und unvergessliche Safari-Erlebnisse vereinen.',
		styleLuxuryPrice: 'Ab ca. CHF 1.200/Nacht',
		styleBudgetTitle: 'Budget-Unterkunft',
		styleBudgetDesc:
			'Genießen Sie authentische, komfortable Unterkünfte mit hervorragendem Preis-Leistungs-Verhältnis, die Sie nah an Südafrikas Tierwelt und natürlicher Schönheit halten.',
		styleBudgetPrice: 'Ab ca. CHF 350/Nacht',
		styleSelfDriveTitle: 'Selbstfahrer-Tour',
		styleSelfDriveDesc:
			'Erkunden Sie Südafrika in Ihrem eigenen Tempo mit einer individuellen Route, handverlesenen Unterkünften und unserer Unterstützung während Ihrer gesamten Reise.',
		styleSelfDrivePrice: 'Ab ca. CHF 480/Nacht',
		styleBig5Title: 'Big-5-Safaritour',
		styleBig5Desc:
			'Erleben Sie fachkundig geführte Pirschfahrten in einigen der besten Wildreservate Südafrikas mit der Gelegenheit, die berühmten Big Five und vieles mehr zu entdecken.',
		styleBig5Price: 'Ab ca. CHF 850/Nacht',
		stylePersonalisedTitle: 'Personalisiertes Paket',
		stylePersonalisedDesc:
			'Eine komplett maßgeschneiderte Reise ganz nach Ihren Wünschen – verbinden Sie Ihre bevorzugten Reiseziele, Unterkünfte, Aktivitäten und Ihren Reisestil zu einer perfekten Route.',
		stylePersonalisedPrice: 'Individuelle Preisgestaltung',
		styleSustainableTitle: 'Nachhaltigkeit & Naturschutz',
		styleSustainableDesc:
			'Entdecken Sie die Naturschutzarbeit hinter Ihrer Safari durch ethische Tierbeobachtungen, Schutzinitiativen und die Möglichkeit, von den Menschen zu lernen, die Südafrikas Tierwelt schützen.',
		styleSustainablePrice: 'Ab ca. CHF 650/Nacht',

		interestBig5Title: 'Big-5-Sichtung',
		interestBig5Label: 'Klassische Safari-Fahrten',
		interestBig5Desc:
			'Erleben Sie unvergessliche Tierbegegnungen auf geführten Pirschfahrten mit der Gelegenheit, die Big Five und die unglaubliche Artenvielfalt Südafrikas zu entdecken.',
		interestSportsTitle: 'Sport & Aktive Erlebnisse',
		interestSportsLabel: 'Outdoor-Abenteuer',
		interestSportsDesc:
			'Bringen Sie Abenteuer in Ihre Reise mit Aktivitäten wie Wandern, Radfahren, Golf, Reiten und weiteren Outdoor-Erlebnissen, abgestimmt auf Ihre Interessen.',
		interestOceanTitle: 'Meeres- & Ozeanerlebnisse',
		interestOceanLabel: 'Küste & Meer',
		interestOceanDesc:
			'Erkunden Sie Südafrikas Küste mit Erlebnissen wie Tauchen, Walbeobachtung, Schildkröten-Beobachtung, Surfen, Angeln und weiteren maritimen Aktivitäten.',
		interestScenicTitle: 'Rundflüge',
		interestScenicLabel: 'Tiefflug-Routen',
		interestScenicDesc:
			'Erleben Sie Südafrika aus einer neuen Perspektive mit Panoramaflügen über spektakuläre Küsten, Berge, Wildreservate und atemberaubende Landschaften.',
		interestConservationTitle: 'Nachhaltiger Naturschutz',
		interestConservationLabel: 'Ökosystem-Schutz',
		interestConservationDesc:
			'Gewinnen Sie ein tieferes Verständnis für den Schutz der Tierwelt durch ethische Naturschutz-Erlebnisse, Bildungsangebote und Einblicke in die Arbeit vor Ort.',
		interestCulinaryTitle: 'Gourmet-Erlebnis',
		interestCulinaryLabel: 'Essen & Wein vom Feinsten',
		interestCulinaryDesc:
			'Entdecken Sie Südafrika kulinarisch – von traditionellen lokalen Spezialitäten und Weingut-Besuchen bis hin zu Spitzenrestaurants und unvergesslichen Bush-Dinners.',
		interestPhotographyTitle: 'Tierfotografie',
		interestPhotographyLabel: 'Foto-Masterclass',
		interestPhotographyDesc:
			'Flüge ohne Türen für perfekte Fotos, Spezial-Halterungen für Kamera und Profi-Begleitung.',

		groupCouple: 'Paar',
		groupFamily: 'Familie',
		groupSolo: 'Alleinreisender',
		groupFriends: 'Gruppe von Freunden',
		groupOther: 'Andere',

		transportOrganised: 'Organisierter Transport',
		transportSelfDrive: 'Selbstfahrer',
		transSelfDriving: 'Selbstfahrer',
		transOrganised: 'Organisierter Transport',

		wizardSuccessSecure: 'Vorschlag sicher registriert',
		wizardSuccessDesc:
			'Souveräne Concession-Tracking-Codes und Fluggenehmigungen sind provisorisch in den lokalen Registern geblockt.',
		wizardSuccessPlanner: 'Reiseplaner:',
		wizardSuccessCredentials: 'Daten gesendet an:',
		wizardSuccessDuration: 'Dauer geplant:',
		wizardSuccessNights: 'Nächte (Mit privater Begleitung)',
		wizardSuccessGroup: 'Gruppengröße:',
		wizardSuccessSecondary: 'Zweite Route designen',
		wizardSuccessUnlock: 'Mit der Übermittlung treten Sie direkt mit unserem Safari-Expertenteam in Kontakt.',
		wizardPrev: 'Zurück',
		wizardNext: 'Weiter',
		wizardSubmit: 'Entwurf anfordern',
		wizardSubmitting: 'Vorschlag wird übermittelt...',
		wizardAssignedId: 'Zugewiesene Concession-ID',
		recommendedLevel: 'Empfohlener Standard',

		// Testimonials / Guest Reviews / Guarantees
		simplifyingJourneyTitle: 'Vereinfachung Ihrer perfekten Reise',
		simplifyingJourneyDesc1:
			'Unsere Reisepaket vereinfachen den Buchungsprozess, indem sie auf alle Arten von Interessen und Budgets eingehen. Wir decken jeden Aspekt Ihrer Reise ab, wie Unterkunft, Aktivitäten und Transfers.',
		simplifyingJourneyDesc2:
			'Wir möchten, dass Sie das Beste aus Ihrer Reise machen und sicherstellen, dass sie ein wunderbares Erlebnis wird, das Sie',
		guestChronicles: 'Gästebewertungen',
		guestChroniclesDesc: 'Echte Erlebnisse: Unsere Gäste wissen es am besten.',
		selectSafariStory: 'Reisebericht auswählen',
		verifiedAdventurer: 'Zertifizierter Reisender • {location}',
		prevReview: 'Vorherige Bewertung',
		nextReview: 'Nächste Bewertung',

		// Testimonial Specific Metadata (leaving quotes in english)
		tripBespokeSelfDrive: 'Maßgeschneiderte Selbstfahrer-Expedition',
		tripCuratedWilderness: 'Kuratierte Wildnis-Safari',
		tripUltraLuxuryAir: 'Ultra-Luxus-Privatflug-Charter',
		highlightFlexibility: 'Flexibilität, absolute Ruhe & Tierbegegnungen am Wasserloch',
		highlightMagical: 'Magische Tierbegegnungen & spektakuläre Nacht-Safaris',
		highlightIncomparable: 'Einzigartiger Luxus & perfektes Wildnis-Erlebnis',
		destTalamati: 'Kruger-Nationalpark (Talamati Bushveld Camp)',
		destLionReserves: 'Kruger-Nationalpark & Löwen-Reservate',
		destSandibe: 'Okavango-Delta (Sandibe-Privatreservat)',

		// Travel Styles UI
		readNarrative: 'Bericht lesen',
		hideNarrative: 'Bericht verbergen',
		discoverOurPackages: 'Entdecken Sie unsere Pakete',
		pristineHighlights: 'Inbegriffene Highlights',
		startFrom: 'Ab',
		ourServicesTab: 'Unsere Services & Reisestile',
		seamlessEnrichingTitle: 'Sorglose, bereichernde Safaris',
		seamlessEnrichingSubtitle1:
			'Unser Ziel bei Elephant Expeditions ist es, unsere Leidenschaft für afrikanische Tiere und das Reisen mit Ihnen zu teilen, indem wir ein reibungsloses und bereicherndes Reiseerlebnis schaffen, das Sie nie vergessen werden.',
		seamlessEnrichingSubtitle2:
			'Maßgeschneidert für Einzelpersonen, Familien und Gruppen aus Europa und der ganzen Welt, richtet sich unser Angebot an alle, die die reiche Tierwelt und Naturschönheit Südafrikas erkunden möchten.',

		// Travel Styles Content German
		style_luxury_title: 'Luxus-Aufenthalte',
		style_luxury_subtitle: 'Erstklassige Unterkünfte in exklusiven Lodges und privaten Reservaten.',
		style_luxury_desc:
			'Tauchen Sie ein in eine Oase der Ruhe. Genießen Sie erstklassige Unterkünfte in exklusiven Lodges und privaten Reservaten, die mit viel Liebe zum Detail gestaltet wurden, um europäischen Luxus mit direktem, ungestörtem Zugang zur Natur zu verbinden.',
		style_luxury_h1: 'Erstklassige Unterkünfte in exklusiven Lodges und privaten Reservaten.',
		style_luxury_h2: 'Geführte Touren zur Tierbeobachtung in exklusive Reservaten.',
		style_luxury_h3: 'Premium-Services wie Spa-Behandlungen und maßgeschneiderte Routen.',
		style_luxury_eco: 'Eco-Luxe Gold-Allianz',

		style_budget_title: 'Günstige Aufenthalte',
		style_budget_subtitle: 'Erschwinglichere Optionen, ohne Kompromisse beim Erlebnis einzugehen.',
		style_budget_desc:
			'Erleben Sie den Zauber der afrikanischen Wildnis hautnah und zu einem erschwinglichen Preis. Wohnen Sie in außergewöhnlichen, charmanten Lodges und Gästehäusern, bei denen Komfort, Wärme und Authentizität im Vordergrund stehen.',
		style_budget_h1: 'Erschwinglichere Optionen, ohne Kompromisse beim Erlebnis einzugehen.',
		style_budget_h2: 'Außergewöhnliche Unterkünfte wie charmante Lodges und Gästehäuser mit Komfort und Qualität.',
		style_budget_h3: 'Geführte Safaritouren, erschwingliche Optionen mit All-Inclusive- oder Selbstverpflegungsplänen.',
		style_budget_eco: 'Grüner Standard für geringen ökologischen Fußabdruck',

		style_selfdrive_title: 'Selbstfahrer-Touren',
		style_selfdrive_subtitle: 'Für abenteuerlustige Reisende, die lieber selbst fahren.',
		style_selfdrive_desc:
			'Der ultimative Weg zu ungeschriebenen persönlichen Entdeckungen. Wir bieten perfekt ausgearbeitete Reiserouten, empfohlene Strecken sowie im Voraus gebuchte Premium-Unterkünfte und -Aktivitäten für eine völlig stressfreie Selbstfahrer-Safari.',
		style_selfdrive_h1: 'Gut geplante Reiserouten, empfohlene Strecken und im Voraus gebuchte Unterkünfte.',
		style_selfdrive_h2: 'Vorschläge für Mietwagen.',
		style_selfdrive_h3: 'Tipps zur Navigation im Gelände und zur Erkundung der Regionen im eigenen perfekten Tempo.',
		style_selfdrive_eco: 'CO2-Kompensation für Reiserouten',

		style_big5_title: 'Big 5 Safari-Touren',
		style_big5_subtitle: 'Maßgeschneiderte Safaris, die auf die Entdeckung der legendären Big 5 ausgerichtet sind.',
		style_big5_desc:
			'Spezielle Safaris, die darauf ausgerichtet sind, die legendären Big 5 zu entdecken: Löwe, Leopard, Elefant, Nashorn und Büffel. Erleben Sie geführte Ausflüge mit Top-Fährtenlesern in den spektakulärsten Nationalparks Südafrikas.',
		style_big5_h1: 'Maßgeschneiderte Safaris, die auf die Sichtung der Big 5 ausgerichtet sind.',
		style_big5_h2: 'Fokus auf die "Big 5"-Tiere mit geführten Touren in atemberaubenden Reservaten und Nationalparks.',
		style_big5_h3: 'Hervorragende Möglichkeiten für Spurensuche, Fotografie und lehrreiche Buscherlebnisse.',
		style_big5_eco: 'Subventionen der Ranger-Unterstützungsstiftung',

		style_personalized_title: 'Personalisierte Pakete',
		style_personalized_subtitle: 'Mehr als nur ein Safari-Erlebnis. Maßgeschneidert für Sie.',
		style_personalized_desc:
			'Maßgeschneiderte Designs, um Ihre persönliche Definition des ultimativen Wildnisabenteuers zu verwirklichen. Erleben Sie den echten Geschmack Afrikas, egal ob Sie unberührte Tierwelt, malerische Panoramen, erstklassige Kulinarik oder tiefe kulturelle Verbindungen suchen.',
		style_personalized_h1:
			'Auf Ihre Vorlieben zugeschnitten: Tierwelt, malerische Landschaften, Strandleben sowie kulinarische oder kulturelle Erlebnisse.',
		style_personalized_h2: 'Aktivitäten wie Rundflüge, Flusspfärdfahrten, Walbeobachtung und Hochseefischen.',
		style_personalized_h3:
			'Möglichkeit der Begleitung durch einen professionellen Fotoguide, um Ihre Reise festzuhalten.',
		style_personalized_eco: 'Direkte Löhne für lokale Gemeinschaften',

		style_sustainable_title: 'Nachhaltige Interaktionen',
		style_sustainable_subtitle: 'Naturschutzerlebnisse. Tauchen Sie ein in den Schutz der Tierwelt.',
		style_sustainable_tag: 'Aktive Vormundschaft',
		style_sustainable_desc:
			'Tauchen Sie tief in den aktiven Naturschutz ein. Beteiligen Sie sich an praktischen, hochintegren Tier- und Naturschutzprojekten, die Ihnen ein tiefes Verständnis für Südafrikas Schutzbemühungen vermitteln.',
		style_sustainable_h1: 'Praktische Erfahrungen für ein tiefes Verständnis des Schutzes der afrikanischen Tierwelt.',
		style_sustainable_h2:
			'Teilnahme an Nashorn-Enthornungsprojekt, Schuppentier-Beobachtungen oder Monitoring-Sitzungen.',
		style_sustainable_h3: 'Nachhaltige Interaktionen wie Elefantenbegegnungen, die das Wohlergehen der Tiere schützen.',
		style_sustainable_eco: '100% ethische Zertifizierung genehmigt',
	},
};
